"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.mtChatApp = angular.module('mtChatApp', ['ui.router', 'ui.bootstrap', 'ngSanitize', 'oc.lazyLoad', 'ngScrollbars', 'cgNotify', 'angularFileUpload']);
mtChatApp.controller('InitCntrl', ['$rootScope', '$scope', '$timeout', '$state', 'constant', 'dataService', 'mqttService', 'utilFactory', 'utilService', 'textToSpeech', function ($rootScope, $scope, $timeout, $state, constant, dataService, mqttService, utilFactory, utilService, textToSpeech) {
  logger.verbose("Load Init Cntrl >>>>>");
  localStorage.a8BaseURL = window.baseURL;
  dataService.isChatWindowLoaded = false;
  var botEvents = {
    Max: "chatWidget.onMaximize",
    Min: "chatWidget.onMinimize",
    Close: "chatWidget.onClose",
    Open: "chatWidget.onOpen"
  };
  var lastTabAction = null;
  var replyTimer = null;
  var a8bot_sto = {
    botHandles: {}
  };
  var botHandle = null;

  if (localStorage.a8bot_sto) {
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
  }

  dataService.notificaitonReplyQueue = {};

  function receiveFrameMessage(event) {
    var data = JSON.parse(event.data);
    logger.verbose("<<<<< Receive iframe message events: " + JSON.stringify(data));

    if (!data.type || !data.hostedURL) {
      return;
    } // if (event.data.userId && event.data.userId != utilFactory.getValueFromStore('userId', '')) {
    //     utilFactory.clearSession();
    //     utilFactory.setValueToStore('userId', event.data.userId);
    // }
    // if (event.data.clientId) {
    //     sessionStorage.clientId = event.data.clientId;
    // }


    botHandle = data.botHandle;
    dataService.botHandle = botHandle;
    dataService.mqttClientId = data.mqttClientId;

    if (a8bot_sto && a8bot_sto.botHandles) {
      if (!a8bot_sto.botHandles[botHandle] || a8bot_sto.botHandles[botHandle] && !a8bot_sto.botHandles[botHandle].userId || a8bot_sto.botHandles[botHandle].userId != data.userId) {
        a8bot_sto.botHandles[botHandle] = {
          userId: data.userId,
          clientId: null,
          selectedTopics: null,
          msgInQueue: 0
        };
      } // delete sessionStorage.userId;
      // delete sessionStorage.clientId;
      // delete sessionStorage.userId;
      // delete sessionStorage.selectedTopics;
      // delete sessionStorage.msgInQueue;


      a8bot_sto.botHandles[botHandle].userId = data.userId;
    }

    updateStorage();
    logger.verbose("<<<<< Receive Vaild Post Message" + data.type + " - " + data.action);
    dataService.hostedURL = data.hostedURL;

    if (data.type === "USERINFO") {
      if (!dataService.isChatWindowLoaded) {
        // dataService.botName = event.data.botName;
        dataService.userInfo = {
          id: data.userId,
          botHandle: botHandle,
          name: data.displayName,
          email: data.email,
          userId: data.userId,
          displayName: data.displayName,
          timeZone: data.timezone,
          clientId: data.clientId,
          sessionKey: data.sessionKey,
          machineId: data.machineId,
          suggestion: data.suggestion,
          hideInputPanel: data.hideInputPanel,
          thumbsupLastTouched: data.thumbsupLastTouched,
          customFields: data.customFields,
          appKey: data.appKey,
          orgId: data.orgId,
          domainURL: data.domainURL,
          isSmallScreen: data.isSmallScreen
        };

        if (data.clientId) {
          // sessionStorage.clientId = event.data.clientId;
          a8bot_sto.botHandles[botHandle].clientId = data.clientId;
          updateStorage();
        }

        dataService.suggesstionActionEnable = data.suggestion;
        dataService.hideInputPanelEnable = data.hideInputPanel;

        if (data.configuration.defaultWidgetUIState) {
          var widgetUIState = data.configuration.defaultWidgetUIState;

          if (widgetUIState.keyboard) {
            dataService.widgetUIState.keyboard = widgetUIState.keyboard.toLowerCase();
          }

          if (widgetUIState.agentTransfer) {
            dataService.widgetUIState.agentTransfer = widgetUIState.agentTransfer.toLowerCase();
          }

          if (widgetUIState.attachment) {
            dataService.widgetUIState.attachment = widgetUIState.attachment.toLowerCase();
          }
        }

        constant.botTheme = data.botTheme;
        constant.configuration = data.configuration;
        constant.WidgetWidth = data.width;
        constant.WidgetHeight = data.height;
        dataService.tabStatus = data.action;

        if (data.conversations) {
          loadConversationHistory(data);
        }

        if (dataService.chat.status != "Online") {
          mqttService.connectMQTTBroker();
        } // $scope.$broadcast('setHeight');
        // $scope.$broadcast('setWidth');                                        

      }
    } else if (data.type === "TAB") {
      if (!dataService.isChatWindowLoaded) {
        dataService.isChatWindowLoaded = true;

        if (constant.configuration.textToSpeech) {
          textToSpeech.init();
        }

        $state.go('chat');
      } else {
        if (lastTabAction != data.action && botEvents[data.action]) {
          lastTabAction = data.action;
          mqttService.sendChatPreflightEvent(botEvents[data.action], {});
        }
      }

      if (data.action == "Open") {
        if (a8bot_sto.botHandles[botHandle].selectedTopics) {
          var selectedTopics = getSelectedTopics();

          if (selectedTopics) {
            if (selectedTopics[selectedTopics.current].chatId) {
              getChatConversation(selectedTopics[selectedTopics.current].chatId);
            }
          }
        }
      }

      dataService.isSmallScreen = data.isSmallScreen;
      constant.WidgetWidth = data.width;
      constant.WidgetHeight = data.height;
      dataService.tabStatus = data.action;
      $scope.$broadcast('setPos');
      $scope.$broadcast('setHeight');
      $scope.$broadcast('setWidth');
      $scope.$broadcast('renderSVG');
      $rootScope.$broadcast('onTabEvent');
    } else if (data.type === "USERMETAINFO") {
      var tempStore = JSON.parse(localStorage.getItem('a8bot_sto'));
      var flag = tempStore['botHandles'].isSentMetaInfo ? tempStore['botHandles'].isSentMetaInfo : 0;

      if (!flag) {
        if (!dataService.userMetaInfo && data.userMetaInfo.chatId == null) {
          dataService.userMetaInfo = data.userMetaInfo;
          dataService.userMetaInfo.chatId = "";
          mqttService.sendMetaUserInfo();
        }

        tempStore['botHandles'].isSentMetaInfo = 1;
        localStorage.setItem('a8bot_sto', JSON.stringify(tempStore));
      }
    } else if (data.type === "REPLYMSG") {
      var nReplyId = utilFactory.generateUniqueId('nReplyId');
      dataService.notificaitonReplyQueue[nReplyId] = data.msg;

      if (!dataService.isChatWindowLoaded) {
        $state.go('chat');
      }

      sendNotificationReply(nReplyId);
    } else if (data.type === "REQUEST_CHAT") {
      if (data.lStorage) {
        var lStorage = JSON.parse(data.lStorage);

        if (lStorage.botHandles[botHandle].selectedTopics) {
          var selectedTopics = getSelectedTopics();

          if (selectedTopics == null || selectedTopics[selectedTopics.current].chatId == null) {
            a8bot_sto.botHandles[botHandle].selectedTopics = lStorage.botHandles[botHandle].selectedTopics;
            selectedTopics = lStorage.botHandles[botHandle].selectedTopics;

            if (!a8bot_sto.botHandles[botHandle].appLoaded || a8bot_sto.botHandles[botHandle].appLoaded != 1 || !utilFactory.isNotNullOrUndefinedString(botEvents[data.action])) {
              a8bot_sto.botHandles[botHandle].appLoaded = 1;
              updateStorage();
              mqttService.requestChat("chatWidget.onLoad");

              if (utilFactory.isNotNullOrUndefinedString(botEvents[data.action])) {
                mqttService.requestChat(botEvents[data.action]);
              }
            } else if (data.action) {
              mqttService.requestChat(botEvents[data.action]); // || "chatWidget.onLoad"
            }
          }

          if (!a8bot_sto.botHandles[botHandle].selectedTopics[selectedTopics.current].widgetUIState) {
            a8bot_sto.botHandles[botHandle].selectedTopics[selectedTopics.current].widgetUIState = dataService.widgetUIState;
          }

          updateStorage();
        }
      }
    } else if (data.type === "KEYBOARD") {
      // console.log("KEYBOARD", data)
      constant.WidgetWidth = data.width;
      constant.WidgetHeight = data.height;
      $scope.$broadcast('setHeight');
      $scope.$broadcast('setWidth');
    }

    data['ack'] = true;
    data['tabStatus'] = dataService.tabStatus;
    logger.verbose("<<<<<<< send parent ack: " + data.type);
    parent.postMessage(data, dataService.hostedURL);
  }

  function sendNotificationReply(nReplyId) {
    if (dataService.notificaitonReplyQueue[nReplyId]) {
      $rootScope.$broadcast('onNotificationReply', dataService.notificaitonReplyQueue[nReplyId], nReplyId, "ReplyMessage");
      replyTimer = $timeout(function () {
        sendNotificationReply(nReplyId);
      }, 3000);
    }
  }

  function updateStorage() {
    // console.trace();
    // console.log("B: ", localStorage.a8bot_sto)            
    localStorage.setItem('a8bot_sto', JSON.stringify(a8bot_sto)); // console.log("A: ", localStorage.a8bot_sto)

    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    $rootScope.$broadcast('onStorageUpdate', {
      'triggeredBy': 'APP'
    });
  }

  $scope.$on('onWidgetUIState', function (event, data) {
    if (data.keyboard) {
      dataService.widgetUIState.keyboard = data.keyboard.toLowerCase();
    }

    if (data.agentTransfer) {
      dataService.widgetUIState.agentTransfer = data.agentTransfer.toLowerCase();
    }

    if (data.attachment) {
      dataService.widgetUIState.attachment = data.attachment.toLowerCase();
    }
  });
  $scope.$on('onStorageUpdate', function (event, triggeredBy) {
    if (triggeredBy != "APP") {
      a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    }
  });

  function getSelectedTopics() {
    if (localStorage.a8bot_sto) {
      a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    }

    if (typeof a8bot_sto.botHandles[botHandle].selectedTopics == "string") {
      return JSON.parse(a8bot_sto.botHandles[botHandle].selectedTopics);
    } else if (_typeof(a8bot_sto.botHandles[botHandle].selectedTopics) == "object") {
      return a8bot_sto.botHandles[botHandle].selectedTopics;
    } else {
      return null;
    }
  }

  function getChatConversation(chatId) {
    var httpConfig = {
      "url": window.baseURL + config.getChatTranscript.replace("{chatId}", chatId),
      "method": "GET",
      "headers": {
        "Content-Type": "application/json",
        "x-app-key": dataService.userInfo.appKey,
        "x-org-id": dataService.userInfo.orgId,
        "x-client-id": a8bot_sto.botHandles[botHandle].clientId,
        "x-bot-handle": dataService.userInfo.botHandle
      },
      "successCallback": function successCallback(status, data, headers) {
        var messages = [];

        if (data.chatConversation && data.chatConversation.length > 0 && data.chatConversation[0].messages) {
          for (var i in data.chatConversation[0].messages) {
            var msg = data.chatConversation[0].messages[i];

            if (msg.sentAt) {
              msg['timestamp'] = msg.sentAt;
              msg['dateTimeFormatted'] = utilFactory.toCustomDateTimeFormat(new Date(new Date(msg.sentAt).getTime()));
            }

            msg['from'] = {};
            msg.from['userId'] = msg.fromId;
            messages.push(msg);
          }

          dataService.chat.msg = [];
          dataService.chat.msg = messages;
          $rootScope.$broadcast('onMessageUpdate', {
            "action": "Inbox"
          });
        }
      },
      "failureCallback": function failureCallback(status, data) {
        console.error("Get Chat Conversation: ", status, data);
      }
    };
    utilService.httpService(httpConfig);
  }

  function loadConversationHistory(data) {
    var conversations = data.conversations;

    for (var i in conversations.messages) {
      var chat = {};

      if (conversations.messages[i].sentAt) {
        chat['timestamp'] = conversations.messages[i].sentAt;
        chat['dateTimeFormatted'] = utilFactory.toCustomDateTimeFormat(new Date(new Date(conversations.messages[i].sentAt).getTime()));
      }

      if (conversations.messages[i].msgType == "text") {
        chat['text'] = conversations.messages[i].msg;
      }

      if (conversations.messages[i].msgType == "attachments") {
        chat['attachments'] = conversations.messages[i].msg;
      }

      if (conversations.messages[i].greet) {
        chat['greet'] = conversations.messages[i].greet;
      }

      if (conversations.messages[i].nlpResponse) {
        chat['nlpResponse'] = conversations.messages[i].nlpResponse;
      }

      if (conversations.messages[i].fromBot) {
        chat['from'] = {
          'name': data.botName,
          'userId': null
        };
      } else {
        chat['from'] = {
          'userId': data.userId,
          'displayName': data.displayName
        };
      }

      dataService.chat.msg.push(chat);
    }

    if (dataService.tabStatus == "" || dataService.tabStatus == "Close") {
      var msg = dataService.chat.msg[0];

      if (msg.from.userId != data.userId) {
        parent.postMessage({
          type: 'Notification',
          msg: msg,
          tabStatus: dataService.tabStatus
        }, dataService.hostedURL);
      }
    }
  }

  $scope.$on('connectionStatus', function (event, data) {
    if (dataService.chat.status == "Online") {
      parent.postMessage({
        type: 'Online',
        tabStatus: dataService.tabStatus
      }, dataService.hostedURL);
    }
  });

  if (window.attachEvent) {
    window.attachEvent('onmessage', receiveFrameMessage);
  } else {
    window.addEventListener('message', receiveFrameMessage, false);
  }

  $scope.$on('onMsgNotification', function (event, msg) {
    if (dataService.tabStatus == "" || dataService.tabStatus == "Close") {
      parent.postMessage({
        type: 'Notification',
        msg: msg,
        tabStatus: dataService.tabStatus,
        widgetUIState: dataService.widgetUIState
      }, dataService.hostedURL);
    }
  });

  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
      var k;

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);
      var len = o.length >>> 0;

      if (len === 0) {
        return -1;
      }

      var n = fromIndex | 0;

      if (n >= len) {
        return -1;
      }

      k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      while (k < len) {
        if (k in o && o[k] === searchElement) {
          return k;
        }

        k++;
      }

      return -1;
    };
  }
}]);
"use strict";

// var config = {
//     getConfig: "/client/v1/configuration",
//     getChatTranscript: "/client/v1/chats/{chatId}",
//     getTopics: "/client/v1/topics",
//     attachmentUrl: "/client/v1/storage/forchat/newfile",
//     ttsUrl: "https://westus.tts.speech.microsoft.com/cognitiveservices/v1",
//     ttsTokenUrl: "https://westus.api.cognitive.microsoft.com/sts/v1.0/issueToken",
//     subscriptionKey: "e8d38e176e96433986aa481c46efb0f6",
//     audioOutputFormat: "audio-16khz-64kbitrate-mono-mp3"
// };
var config = {
  getConfig: "/client/v1/configuration",
  getChatTranscript: "/client/v1/chats/{chatId}",
  getTopics: "/client/v1/topics",
  attachmentUrl: "/client/v1/storage/forchat/newfile",
  ttsUrl: "https://centralindia.tts.speech.microsoft.com/cognitiveservices/v1",
  ttsTokenUrl: "https://centralindia.api.cognitive.microsoft.com/sts/v1.0/issuetoken",
  subscriptionKey: "cd3288c885e64560a00eb5ebf061a028",
  audioOutputFormat: "audio-16khz-64kbitrate-mono-mp3"
};
"use strict";

mtChatApp.constant('constant', {
  AppName: 'MTChatApp',
  AppVersion: 1.0,
  ApiUrl: '/',
  WidgetHeader: 84,
  WidgetTextArea: 48,
  WidgetSuggesstion: 56,
  WidgetHeight: 0,
  WidgetWidth: 0,
  Theme: null,
  botTheme: {},
  Env: "testing",
  LimitDaysForThumbup: 7,
  Type: {
    String: 'String',
    Integer: 'Integer',
    Float: 'Float',
    Object: 'object',
    Number: 'number',
    Boolean: 'Boolean'
  }
});
"use strict";

mtChatApp.directive("setWidth", ["constant", "dataService", function (constant, dataService) {
  return {
    link: function link(scope, element, attrs) {
      scope.setWidth = function () {
        // console.log("<<<<< Set Widget Width ");
        var widgetWidth = scope.constant.WidgetWidth;
        var className = attrs["class"];
        var minValue = 112;
        minValue = minValue + (scope.dataService.fabOptionEnable ? 78 : 0); // console.log(minValue);

        if (className.match("_typingArea") && className.match("_typingArea")[0] === "_typingArea") {
          var mLeft = scope.dataService.fabOptionEnable ? 34 + "px" : "0px";
          element.css({
            "margin-left": "0px",
            "width": widgetWidth - minValue + "px"
          });
        }
      };

      scope.$on("setWidth", function (event) {
        scope.setWidth();
      });
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("setHeight", ["constant", "dataService", function (constant, dataService) {
  return {
    link: function link(scope, element, attrs) {
      scope.setHeight = function () {
        // console.log("<<<<< Set Widget Height ");
        var widgetHeight = scope.constant.WidgetHeight;
        var className = attrs["class"];
        var minValue = scope.constant.WidgetHeader + (scope.dataService.hideInputPanelEnable ? 25 : scope.constant.WidgetTextArea) + (scope.dataService.suggesstionActionEnable ? scope.constant.WidgetSuggesstion : 0);
        var bottom = scope.dataService.suggesstionActionEnable ? 92 : 64; // if (className.match("_file-upload-panel") && className.match("_file-upload-panel")[0] === "_file-upload-panel") {
        //     element.css('height', (widgetHeight - minValue) + 'px');
        //     element.css('bottom', bottom + 'px');
        // }

        if (className.match("_bubbles-outer") && className.match("_bubbles-outer")[0] === "_bubbles-outer") {
          element.css("height", widgetHeight - minValue + "px");
          $("._msgs").css("height", widgetHeight - (minValue + (scope.dataService.isSmallScreen ? 20 : 0)) + "px");
          $("._msgs").css("bottom", bottom + "px");
        }

        if (scope.dataService.tabStatus == "Max") {
          $("._typing-area").css({
            width: "98%"
          });
          $("._feedback_thumb").css({
            width: "24%",
            "padding-top": "5px"
          });
        } else {
          $("._typing-area").css({
            width: "94%"
          });
          $("._feedback_thumb").css({
            width: "36%",
            "padding-top": "36px"
          });
        }
      };

      scope.$on("setHeight", function (event) {
        scope.setHeight();
      });
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubbleTableChoice", ["constant", "dataService", "$rootScope", function (constant, dataService, $compile) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg",
      _index: "=last"
    },
    templateUrl: 'uikit/' + uikitRender.tableChoice.v1.render(),
    link: function link(scope, element, attrs) {
      scope.check();
      $(".table-body").bind('mousewheel', function (e) {
        if (e.currentTarget.className == "table-body") {// e.preventDefault();
          // e.stopPropagation();
        }
      });
    },
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      $scope.chatTableScrollConfig = {
        autoHideScrollbar: false,
        theme: 'light',
        axis: 'yx',
        alwaysShowScrollbar: 2,
        scrollButtons: {
          enable: true //  scrolling buttons by default

        },
        advanced: {
          updateOnContentResize: true
        },
        scrollInertia: 0,
        callbacks: {
          onScroll: function onScroll() {
            $(".table-header").css({
              left: this.mcs.left
            });
          },
          whileScrolling: function whileScrolling() {// console.log(1, this.mcs);
          }
        }
      };
      $scope.cardWidth = {
        'width': '94%'
      };
      $scope.constant = constant;
      $scope.headingText = {
        'color': $scope.constant.botTheme.global.primaryFontColor
      };

      $scope.check = function () {
        $(document).on("load", ".tableview", function () {
          $(this).find("th").attr('style', 'background:' + $scope.constant.botTheme.global.primaryColor + ' !important');
        });
      };

      $scope.dataService = dataService;

      if ($scope._index) {
        $scope.show = true;
      }

      $scope.data = $scope._chatMsg.msg;
    }]
  };
}]).directive("setPos", ["constant", "dataService", function (constant, dataService) {
  return {
    link: function link(scope, element, attrs) {
      scope.setPos = function () {
        // console.log("<<<<< Set Widget Position ");
        var widgetHeight = scope.constant.WidgetHeight;
        var className = attrs["class"];
        var minValue = scope.constant.WidgetHeader + scope.constant.WidgetTextArea + (scope.dataService.suggesstionActionEnable ? scope.constant.WidgetSuggesstion : 0);

        if (className.match("_typing") && className.match("_typing")[0] === "_typing") {
          if (dataService.isBotTyping) {
            element.css({
              top: widgetHeight - (minValue - 30) + "px"
            });
          }
        }
      };

      scope.$on("setPos", function (event) {
        scope.setPos();
      });
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("setTheme", ["constant", function (constant) {
  return {
    link: function link(scope, element, attrs) {
      if (scope.constant && scope.constant.botTheme) {
        if (scope.constant.botTheme.global) {
          $(".mt-web-chat").addClass(scope.constant.botTheme.global.primaryFont);
          $("body").css({
            'font-family': scope.constant.botTheme.global.primaryFont
          });
          $("body").attr({
            'style': 'font-family:' + scope.constant.botTheme.global.primaryFont + ' !important'
          });
          $(".footer").attr({
            'style': 'font-family:' + scope.constant.botTheme.global.primaryFont + ' !important'
          });
          $(".chat-box").css({
            'font-family': scope.constant.botTheme.global.primaryFont
          });
        }

        if (attrs.propName == "send" || attrs.propName == "attach") {
          element.css({
            // 'font-family': scope.constant.botTheme.global.primaryFont,
            color: scope.constant.botTheme.bot.avatarStyle.background,
            padding: '8px'
          });
        } else if (attrs.propName == "doodle") {
          if (scope.constant.botTheme.global.doodle != null) {
            element.css("background-image", scope.constant.botTheme.global.doodle);
          } else {
            element.hide();
          }
        } else if (attrs.propName == "feedback-submit") {
          element.css({
            background: scope.constant.botTheme.global.primaryColor,
            color: scope.constant.botTheme.global.foreColor
          });
        } else if (attrs.propName == "bot-dp") {
          $(".mt-web-chat .chat .suggestions .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar").css({
            "background-color": scope.constant.botTheme.global.scrollBarColor ? scope.constant.botTheme.global.scrollBarColor : scope.constant.botTheme.global.primaryColor
          });
          $(".mt-web-chat .chat .bubbles .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar").css({
            "background-color": scope.constant.botTheme.global.scrollBarColor ? scope.constant.botTheme.global.scrollBarColor : scope.constant.botTheme.global.primaryColor,
            "width": scope.constant.botTheme.global.scrollBarVHeight + "px"
          });
          $(".mt-web-chat .chat .suggestions .mCSB_scrollTools .mCSB_draggerRail").css({
            "background-color": scope.constant.botTheme.global.scrollBarBGColor
          });
          $(".mt-web-chat .chat .suggestions .mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar").css({
            "height": scope.constant.botTheme.global.scrollBarHHeight + "px"
          });
          element.css($.extend({
            background: scope.constant.botTheme.global.primaryColor,
            color: scope.constant.botTheme.global.foreColor
          }, scope.constant.botTheme.bot && scope.constant.botTheme.bot.avatarStyle ? scope.constant.botTheme.bot.avatarStyle : {}));
        } else if (attrs.propName == "client-dp") {
          $(".mt-web-chat .chat .suggestions .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar").css({
            "background-color": scope.constant.botTheme.global.primaryColor
          });
          $(".mt-web-chat .chat .bubbles .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar").css({
            "background-color": scope.constant.botTheme.global.primaryColor
          });
          element.css($.extend({
            background: scope.constant.botTheme.global.primaryColor,
            color: scope.constant.botTheme.global.foreColor
          }, scope.constant.botTheme.user && scope.constant.botTheme.user.avatarStyle ? scope.constant.botTheme.user.avatarStyle : {}));
        } else if (attrs.propName == "suggestion") {
          element.css({
            "border-color": scope.constant.botTheme.global.primaryColor,
            color: scope.constant.botTheme.global.primaryColor
          });
          element.bind("mouseleave", function (e) {
            element.css({
              background: "",
              color: ""
            });
          });
          element.bind("mouseover", function (e) {
            element.css({
              background: scope.constant.botTheme.global.primaryColor,
              color: scope.constant.botTheme.global.foreColor
            });
          });
        } //theme-prop-name for theme integration


        if (attrs.themePropName == "botMsgTextStyle") {
          element.css(scope.constant.botTheme && scope.constant.botTheme.bot.msgTextStyle ? scope.constant.botTheme.bot.msgTextStyle : {});
        } else if (attrs.themePropName == "time-line-user") {
          element.css(scope.constant.botTheme && scope.constant.botTheme.user.timeLineStyle ? scope.constant.botTheme.user.timeLineStyle : {});
        } else if (attrs.themePropName == "time-line-bot") {
          element.css(scope.constant.botTheme && scope.constant.botTheme.bot.timeLineStyle ? scope.constant.botTheme.bot.timeLineStyle : {});
        } else if (attrs.themePropName == "userMsgTextStyle") {
          element.css(scope.constant.botTheme && scope.constant.botTheme.user.msgTextStyle ? scope.constant.botTheme.user.msgTextStyle : {});
        } else if (attrs.themePropName == "botMsgWrapperStyle") {
          element.css(scope.constant.botTheme && constant.botTheme.bot.msgWrapperStyle ? constant.botTheme.bot.msgWrapperStyle : {});
        } else if (attrs.themePropName == "userMsgWrapperStyle") {
          element.css(scope.constant.botTheme && scope.constant.botTheme.user.msgWrapperStyle ? scope.constant.botTheme.user.msgWrapperStyle : {});
        } else if (attrs.themePropName == "typingAreaStyle") {
          element.css(scope.constant.botTheme && constant.botTheme.typingBox.wrapperStyle ? Object.assign(scope.constant.botTheme.typingBox.wrapperStyle, {
            'align-items': 'center'
          }) : {});
        } else if (attrs.themePropName == "botAvatar") {
          element.css(scope.constant.botTheme && scope.constant.botTheme.bot.botAvatar ? {
            "background-image": "url(" + scope.constant.botTheme.bot.botAvatar + ")",
            "background-repeat": "no-repeat"
          } : {}, scope.constant.botTheme.bot && scope.constant.botTheme.bot.avatarStyle ? scope.constant.botTheme.bot.avatarStyle : {});
        } else if (attrs.themePropName == "userAvatar") {
          element.css($.extend(scope.constant.botTheme && scope.constant.botTheme.user.userAvatar ? {
            "background-image": "url(" + scope.constant.botTheme.user.userAvatar + ")",
            "background-repeat": "no-repeat"
          } : {}, scope.constant.botTheme.user && scope.constant.botTheme.user.avatarStyle ? scope.constant.botTheme.user.avatarStyle : {}));
        } else if (attrs.themePropName == "userAvatarTextStyle") {
          element.css(scope.constant.botTheme.user && scope.constant.botTheme.user.avatarTextStyle ? scope.constant.botTheme.user.avatarTextStyle : {});
        } else if (attrs.themePropName == "botAvatarTextStyle") {
          element.css(scope.constant.botTheme.bot && scope.constant.botTheme.bot.avatarTextStyle ? scope.constant.botTheme.bot.avatarTextStyle : {});
        }
      }
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
    }]
  };
}]).directive("ngEnter", function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.ngEnter);
        });
        event.preventDefault();
      }
    });
  };
}).directive("fileBrowser", ["$rootScope", function (rootScope) {
  return {
    restrict: "A",
    replace: true,
    transclude: true,
    scope: false,
    template: '<div class="input-prepend extended-date-picker">' + '<img src="images/attach.svg" />' + '<div class="proxied-field-wrap" ng-transclude></div>' + "</div>",
    link: function link(scope, element, attrs, controller) {
      var fileField;
      fileField = element.find('[type="file"]').on("change", function (event) {
        var fileName = angular.element(this).val().split("\\");
        fileName = fileName[fileName.length - 1];
        var contentUrl = URL.createObjectURL(event.target.files[0]);
        var data = [{
          contentType: "image/jpg",
          contentUrl: contentUrl,
          name: "aadhaar.jpg"
        }];
        rootScope.$broadcast("onUploadFile", {
          file: data
        });
      });
      element.find("img").on("click", function () {
        fileField.trigger("click");
      });
    }
  };
}]).directive("chatBubble", ["constant", "dataService", function (constant, dataService) {
  return {
    link: function link(scope, element, attrs) {
      var chatMsg = JSON.parse(attrs.propName);
      var chatMsgUI = "";

      if (chatMsg.attachments) {
        chatMsgUI = chatMsgAttachments(chatMsg.attachments);
      } else if (chatMsg.text) {
        chatMsgUI = chatMsg.text;
        chatMsgUI = chatMsgUI.replace(/\\n/g, "<br /><br />");
        chatMsgUI = chatMsgUI.replace(/\n/g, "<br />");
        chatMsgUI = chatMsgUI.replace(/<script>/g, "").replace(/<\/script>/g, "");
        chatMsgUI = "<div>" + chatMsgUI + "</div>";
      }

      element.append(chatMsgUI);

      function chatMsgAttachments(attachments) {
        for (var att in attachments) {
          if (attachments[att].content.type == "AdaptiveCard") {
            return renderAdaptiveCard(attachments[att].content);
          }
        }
      }

      function renderAdaptiveCard(cardData) {
        var adaptiveCard = new AdaptiveCards.AdaptiveCard();
        adaptiveCard.parse(cardData);
        return adaptiveCard.render();
      }
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubbleClientCardChoice", ["constant", "dataService", "$rootScope", function (constant, dataService, $compile) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg",
      _index: "=last"
    },
    templateUrl: 'uikit/' + uikitRender.cardChoiceResponse.v1.render(),
    link: function link(scope, element, attrs) {
      scope.check();
    },
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      $scope.cardWidth = {
        'width': '94%'
      };
      $scope.constant = constant;
      $scope.stripes = {
        'background': $scope.constant.botTheme.global.primaryColor
      };

      $scope.check = function () {
        $(document).on("mouseenter", ".cardchoice li", function () {
          $(this).css({
            background: $scope.constant.botTheme.global.primaryColor,
            color: $scope.constant.botTheme.global.foreColor
          });
          $(this).find(".stripes").attr('style', 'background:#fff !important');
          $(this).find("p").attr('style', 'color:#fff !important');
        });
        $(document).on("mouseleave", ".cardchoice li", function () {
          $(this).css({
            background: "",
            color: ""
          });
          $(this).find(".stripes").attr('style', 'background:' + $scope.constant.botTheme.global.primaryColor + ' !important');
          $(this).find("p").attr('style', 'color:unset !important');
        });
      };

      $scope.classes = [{
        row: 'list-group-item row-card',
        group: 'list-group row-list-group'
      }, {
        row: 'list-group-item row-card',
        group: 'list-group row-list-group'
      }];
      $scope["class"] = $scope.classes[1];
      $scope.data = $scope._chatMsg.msg;
    }]
  };
}]).directive("chatBubbleCardChoice", ["constant", "dataService", "$rootScope", function (constant, dataService, $compile) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg",
      _index: "=last"
    },
    templateUrl: 'uikit/' + uikitRender.cardChoice.v1.render(),
    link: function link(scope, element, attrs) {
      scope.check();
    },
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      $scope.cardWidth = {
        'width': '94%'
      };
      $scope.constant = constant;
      $scope.stripes = {
        'background': $scope.constant.botTheme.global.primaryColor
      };

      $scope.check = function () {
        $(document).on("mouseenter", ".cardchoice li", function () {
          $(this).css({
            background: $scope.constant.botTheme.global.primaryColor,
            color: $scope.constant.botTheme.global.foreColor
          });
          $(this).find(".stripes").attr('style', 'background:#fff !important');
          $(this).find("p").attr('style', 'color:#fff !important');
        });
        $(document).on("mouseleave", ".cardchoice li", function () {
          $(this).css({
            background: "",
            color: ""
          });
          $(this).find(".stripes").attr('style', 'background:' + $scope.constant.botTheme.global.primaryColor + ' !important');
          $(this).find("p").attr('style', 'color:unset !important');
        });
      };

      $scope.dataService = dataService;
      if ($scope._index) $scope.show = true;
      $scope.classes = [{
        row: 'list-group-item row-card',
        group: 'list-group row-list-group'
      }, {
        row: 'list-group-item row-card',
        group: 'list-group row-list-group'
      }];
      $scope["class"] = $scope.classes[1];
      $scope.data = $scope._chatMsg.msg;

      if ($scope.data.msg.style.orientation == "H") {
        $scope["class"] = $scope.classes[0];
        $scope.cardWidth = {
          'width': '45%'
        };
      }

      $scope.$on("hideChoices", function () {
        $scope.show = false;
      });

      $scope.sendResponse = function (selectedItem) {
        $scope.show = false;
        var map = {
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
          "/": '&#x2F;'
        };
        var reg = /[<>"'/]/ig;
        selectedItem.label = selectedItem.label.replace(reg, function (match) {
          return map[match];
        });
        selectedItem.subText = selectedItem.subText.replace(reg, function (match) {
          return map[match];
        });
        var msg = {
          msgType: 'cardChoiceResponse',
          msg: selectedItem
        };
        $rootScope.$broadcast('onSendRichReply', msg);
      };
    }]
  };
}]).directive("chatBubbleOauthList", ["constant", "dataService", "$rootScope", function (constant, dataService, $compile) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg",
      _index: "=last"
    },
    templateUrl: 'uikit/' + uikitRender.oauthList.v1.render(),
    link: function link(scope, element, attrs) {
      scope.check();
    },
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      // console.log({'check message object':$scope._chatMsg});
      $scope.constant = constant;

      $scope.check = function () {
        $(document).on("mouseenter", ".oauthList li", function () {
          $(this).css({
            background: $scope.constant.botTheme.global.primaryColor,
            color: $scope.constant.botTheme.global.foreColor
          });
        });
        $(document).on("mouseleave", ".oauthList li", function () {
          $(this).css({
            background: "",
            color: ""
          });
        });
      };

      $scope.dataService = dataService;
      if ($scope._index) $scope.show = true;
      $scope.classes = [{
        row: 'list-group-item row-card',
        group: 'list-group row-list-group'
      }, {
        row: 'list-group-item ',
        group: 'list-group'
      }];
      $scope["class"] = $scope.classes[1];
      $scope.data = $scope._chatMsg.msg;

      if ($scope.data.msg.style.orientation == "H") {
        $scope["class"] = $scope.classes[0];
      }

      $scope.$on("hideChoices", function () {
        $scope.show = false;
      });

      $scope.sendResponse = function (oauthLabel, oauthURL) {
        window.open(oauthURL);
        var map = {
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
          "/": '&#x2F;'
        };
        var reg = /[<>"'/]/ig;
        oauthLabel = oauthLabel.replace(reg, function (match) {
          return map[match];
        });
        $rootScope.$broadcast('onNotificationReply', oauthLabel, null, "OAuth");
      }; //uikitRender.singleChoice.v1.render(scope._chatMsg)

    }]
  };
}]).directive("chatBubbleSimpleChoice", ["constant", "dataService", "$rootScope", function (constant, dataService, $compile) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg",
      _index: "=last"
    },
    templateUrl: 'uikit/' + uikitRender.simpleChoice.v1.render(),
    link: function link(scope, element, attrs) {
      scope.check();
    },
    controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {
      // console.log({'check message object':$scope._chatMsg});
      $scope.constant = constant;

      $scope.check = function () {
        $(document).on("mouseenter", ".simplechoice li", function () {
          $(this).css({
            background: $scope.constant.botTheme.global.primaryColor,
            color: $scope.constant.botTheme.global.foreColor
          });
        });
        $(document).on("mouseleave", ".simplechoice li", function () {
          $(this).css({
            background: "",
            color: ""
          });
        });
      };

      $scope.dataService = dataService;
      if ($scope._index) $scope.show = true;
      $scope.classes = [{
        row: 'list-group-item row-card',
        group: 'list-group row-list-group'
      }, {
        row: 'list-group-item ',
        group: 'list-group'
      }];
      $scope["class"] = $scope.classes[1];
      $scope.data = $scope._chatMsg.msg;

      if ($scope.data.msg.style.orientation == "H") {
        $scope["class"] = $scope.classes[0];
      }

      $scope.$on("hideChoices", function () {
        $scope.show = false;
      });

      $scope.sendResponse = function (selectedItem) {
        var map = {
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
          "/": '&#x2F;'
        };
        var reg = /[<>"'/]/ig;
        selectedItem = selectedItem.replace(reg, function (match) {
          return map[match];
        });
        $rootScope.$broadcast('onNotificationReply', selectedItem, null, "SimpleChoice");
      }; //uikitRender.singleChoice.v1.render(scope._chatMsg)

    }]
  };
}]).directive("chatBubbleText", ["constant", "dataService", function (constant, dataService) {
  return {
    link: function link(scope, element, attrs) {
      var chatMsg = JSON.parse(attrs.propName);
      var isAgent = chatMsg.from.userId.indexOf("a/") > -1;
      var chatMsgUI = "";
      chatMsgUI = chatMsg.msg.text;

      if (isAgent == true) {
        chatMsgUI = chatMsgUI.replace(/\\n/g, "<br /><br />");
        chatMsgUI = chatMsgUI.replace(/\n/g, "<br />");
        chatMsgUI = chatMsgUI.replace(/<script>/g, "").replace(/<\/script>/g, "");
        chatMsgUI = chatMsgUI.replace(/&amp;/g, "&");
      }

      chatMsgUI = "<div>" + chatMsgUI + "</div>";
      element.append(chatMsgUI);
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("fabIcon", ["constant", "dataService", "$rootScope", "$timeout", function (constant, dataService, rootScope, $timeout) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _options: "=options"
    },
    templateUrl: 'app/templates/fab.html',
    link: function link(scope, element, attrs) {
      $(element).find(".fab.primary").click(function () {
        if (element.find('dl').hasClass('visible')) {
          rootScope.$broadcast("onOverlayBubble", false);
          element.find('dl').removeClass("visible");
          $(element).find("dl dt button").each(function (item) {
            $(this).removeClass("transform");
          });
          element.find('.fab.primary.fab-base-icon img').removeClass("fab-rotation");
        } else {
          rootScope.$broadcast("onOverlayBubble", true);
          element.find('dl').addClass("visible");
          $(element).find("dl dt button").each(function (item) {
            $(this).addClass("transform");
          });
          element.find('.fab.primary.fab-base-icon img').addClass("fab-rotation");
        }
      });
      scope.$on('onWidgetUIState', function (event, data) {
        $timeout(function () {
          for (var opt in scope._options.buttons) {
            if (data[scope._options.buttons[opt].id]) {
              scope._options.buttons[opt].action = data[scope._options.buttons[opt].id];
            }
          }
        });
      });
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;

      $scope.actionTrigger = function (opt) {
        if (opt.isEnable) {
          opt.onClick();
          $(".fab.primary").click();
        }
      };
    }]
  };
}]).directive("chatBubbleXls", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-file'>" + "<a href='{{_chatMsg.msg.url}}' target='_blank' download='{{_chatMsg.msg.fileName}}' >" + "<img src='images/xls.svg'>" + "</a>" + "<div>{{_chatMsg.msg.desc}}</div>" + "</div>",
    link: function link(scope, element, attrs) {
      scope.showAction = function () {
        scope.isAction = true;
      };

      scope.hideAction = function () {
        scope.isAction = false;
      };
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubbleTxt", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-file'>" + "<a href='{{_chatMsg.msg.url}}' target='_blank' download='{{_chatMsg.msg.fileName}}' >" + "<img src='images/txt.svg'/>" + "</a>" + "<div>{{_chatMsg.msg.desc}}</div>" + "</div>",
    link: function link(scope, element, attrs) {
      scope.showAction = function () {
        scope.isAction = true;
      };

      scope.hideAction = function () {
        scope.isAction = false;
      };
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("speechToText", ["constant", "dataService", "$rootScope", "$timeout", function (constant, dataService, rootScope, $timeout) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _options: "=options"
    },
    templateUrl: 'app/templates/speechToText.html',
    link: function link(scope, element, attrs) {},
    controller: ["$scope", function controller($scope) {
      var subscriptionKey = $scope._options.subscriptionKey;
      var serviceRegion = $scope._options.region;
      var authorizationToken;
      var SpeechSDK;
      var recognizer;
      var text = null;
      $scope.$on("onSpeechStart", function (event) {
        startSpeechRecognition();
      });

      $scope.hideSpeechTxt = function (isCancel) {
        text = isCancel ? null : text;
        rootScope.$broadcast('onSpeechStop', {
          text: text
        });
      };

      if (!!window.SpeechSDK) {
        SpeechSDK = window.SpeechSDK; // in case we have a function for getting an authorization token, call it.

        if (typeof RequestAuthorizationToken === "function") {
          RequestAuthorizationToken();
        }
      }

      $scope.recordStart = function () {
        navigator.mediaDevices.getUserMedia({
          audio: true
        }).then(function (stream) {
          startSpeechRecognition();
        })["catch"](function (err) {
          logger.error("Voice Recognizer Pop Error: " + JSON.stringify(err));
        });
      };

      function startSpeechRecognition() {
        if (!SpeechSDK) {
          return;
        } // if we got an authorization token, use the token. Otherwise use the provided subscription key


        var speechConfig;

        if (authorizationToken) {
          speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(authorizationToken, serviceRegion);
        } else {
          if (subscriptionKey === "" || subscriptionKey === "subscription") {
            logger.debug("Please enter your Microsoft Cognitive Services Speech subscription key!");
            return;
          }

          speechConfig = SpeechSDK.SpeechConfig.fromSubscription(subscriptionKey, serviceRegion);
        }

        speechConfig.speechRecognitionLanguage = $scope._options.lang;
        var audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
        recognizer.recognizeOnceAsync(function (result) {
          logger.verbose("Voice Recognizer Result: " + JSON.stringify(result));
          text = result.text; // recognizer.close();

          recognizer = null;
          $scope.hideSpeechTxt();
        }, function (err) {
          logger.error("Voice Recognizer Error: " + JSON.stringify(err));
          recognizer.close();
          recognizer = null;
          $scope.hideSpeechTxt();
        });
      }
    }]
  };
}]).directive("chatBubblePpt", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-file'>" + "<a href='{{_chatMsg.msg.url}}' target='_blank' download='{{_chatMsg.msg.fileName}}' >" + "<img src='images/ppt.svg'/>" + "</a>" + "<div>{{_chatMsg.msg.desc}}</div>" + "</div>",
    link: function link(scope, element, attrs) {
      scope.showAction = function () {
        scope.isAction = true;
      };

      scope.hideAction = function () {
        scope.isAction = false;
      };
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubblePdf", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-file'>" + "<a href='{{_chatMsg.msg.url}}' target='_blank' download='{{_chatMsg.msg.fileName}}' >" + "<img src='images/pdf.svg'/>" + "</a>" + "<div>{{_chatMsg.msg.desc}}</div>" + "</div>",
    link: function link(scope, element, attrs) {
      scope.showAction = function () {
        scope.isAction = true;
      };

      scope.hideAction = function () {
        scope.isAction = false;
      };
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubbleDoc", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-file'>" + "<a href='{{_chatMsg.msg.url}}' target='_blank' download='{{_chatMsg.msg.fileName}}' >" + "<img src='images/doc.svg'/>" + "</a>" + "<div>{{_chatMsg.msg.desc}}</div>" + "</div>",
    link: function link(scope, element, attrs) {
      scope.showAction = function () {
        scope.isAction = true;
      };

      scope.hideAction = function () {
        scope.isAction = false;
      };
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubbleAudio", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-audio'>" + "<div data-ng-mouseover='showAction()' data-ng-mouseleave='hideAction()' >" + "<audio id='{{_chatMsg.id}}_ad' controls preload=auto ng-src='{{_chatMsg.msg.url}}'/>" + "</div>" + "<div>{{_chatMsg.msg.desc}}</div>" + "</div>",
    link: function link(scope, element, attrs) {
      scope.action = "PLAY";
      scope.adPlayer = $(element.context).find("audio")[0];
      scope.isPlayed = false;

      scope.play = function () {
        if (scope.isPlayed) {
          scope.isPlayed = false;
          scope.action = "PLAY";
          scope.adPlayer.pause();
        } else {
          scope.action = "PAUSE";
          scope.isPlayed = true;
          scope.adPlayer.play();
        }
      };

      scope.showAction = function () {
        scope.isAction = true;
      };

      scope.hideAction = function () {
        scope.isAction = false;
      };
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubbleVideo", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-video'>" + "<div data-ng-mouseover='showAction()' data-ng-mouseleave='hideAction()' >" + "<video id='{{_chatMsg.id}}_vd' preload=auto ng-src='{{_chatMsg.msg.url}}'/>" + "<span ng-click='play()' style='color: #383838;position: absolute;font-weight: bold;background: #f0f0f0;padding: 5px;border-radius: 10px;right: 50%;margin-top: 18%;' data-ng-show='isAction' >{{action}}</span>" + "</div>" + "<div>{{_chatMsg.msg.desc}}</div>" + "</div>",
    link: function link(scope, element, attrs) {
      scope.action = "PLAY";
      scope.vdPlayer = $(element.context).find("video")[0];
      scope.isPlayed = false;

      scope.play = function () {
        if (scope.isPlayed) {
          scope.isPlayed = false;
          scope.action = "PLAY";
          scope.vdPlayer.pause();
        } else {
          scope.action = "PAUSE";
          scope.isPlayed = true;
          scope.vdPlayer.play();
        }
      };

      scope.showAction = function () {
        scope.isAction = true;
      };

      scope.hideAction = function () {
        scope.isAction = false;
      };
    },
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("chatBubbleImage", ["constant", "dataService", function (constant, dataService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      _chatMsg: "=chatmsg"
    },
    template: "<div class='chat-bubble-image'>" + "<a href='{{_chatMsg.msg.url}}' target='_blank' download='{{_chatMsg.msg.fileName}}' >" + "<img src='{{_chatMsg.msg.url}}'/>" + "</a>" + "<div>{{_chatMsg.msg.desc}}</div>" + // "<div>{{(_chatMsg.msg.fileSize / 1024 / 1024).toFixed(2)}} MB</div>" +
    "</div>",
    link: function link(scope, element, attrs) {},
    controller: ["$scope", function controller($scope) {
      $scope.constant = constant;
      $scope.dataService = dataService;
    }]
  };
}]).directive("svgIcon", ["constant", "svgFileObjects", "dataService", "utilFactory", function (constant, svgFileObjects, dataService, utilFactory) {
  controller.$inject = ["$scope"];
  function link(scope, element, attrs) {
    function path(icon) {
      return svgFileObjects[icon];
    }

    function renderSVG() {
      var colorCode = "";
      var svgObj = path(attrs.p);

      if (attrs.p == "Thumbsdown" || attrs.p == "FillThumbsdown") {
        colorCode = scope.constant.botTheme.global.primaryColor;

        if (attrs.p == "Thumbsdown") {
          svgObj = svgObj.replace(new RegExp("{height_code}", "g"), 28);
        }
      } else if (attrs.p == "Thumbsup" || attrs.p == "FillThumbsup") {
        colorCode = scope.constant.botTheme.global.primaryColor;

        if (attrs.p == "Thumbsup") {
          svgObj = svgObj.replace(new RegExp("{height_code}", "g"), 28);
        }
      }

      svgObj = svgObj.replace(new RegExp("{class_code_0}", "g"), scope.utilFactory.generateUniqueId("svg_class"));
      svgObj = svgObj.replace(new RegExp("{fill_code_0}", "g"), colorCode);
      element.html(svgObj);
    }

    renderSVG();
    scope.$on("renderSVG", function (event) {
      renderSVG();
    });
  }

  function controller($scope) {
    $scope.svgFileObjects = svgFileObjects;
    $scope.constant = constant;
    $scope.dataService = dataService;
    $scope.utilFactory = utilFactory;
  }

  return {
    controller: controller,
    link: link,
    restrict: "E"
  };
}]).directive("showFocus", function () {
  return {
    link: function link(scope, element, attrs) {
      scope.showFocus = function (className) {
        $("." + className).focus();
      };

      scope.$on("showFocus", function (event, className) {
        scope.showFocus(className);
      });
    }
  };
});
"use strict";

mtChatApp.service('dataService', ['$rootScope', '$state', 'constant', function ($rootScope, $state, constant) {
  var _chat = {
    msg: [],
    status: ""
  };
  var _tabStatus = "";
  var _botName = "";
  var _isBotTyping = false;
  var _hideInputPanelEnable = false;
  var _hideInputPanel = false;
  var _connectAgentEnable = true;
  var _attachActionEnable = false;
  var _fabOptionEnable = true;
  var _sendActionEnable = true;
  var _userInfo = null;
  var _hostAddress = "";
  var _isBotConnected = false;
  var _botHandle = null;
  return {
    chat: _chat,
    botName: _botName,
    userInfo: _userInfo,
    hostAddress: _hostAddress,
    hideInputPanelEnable: _hideInputPanelEnable,
    hideInputPanel: _hideInputPanel,
    connectAgentEnable: _connectAgentEnable,
    attachActionEnable: _attachActionEnable,
    fabOptionEnable: _fabOptionEnable,
    sendActionEnable: _sendActionEnable,
    isBotTyping: _isBotTyping,
    tabStatus: _tabStatus,
    botHandle: _botHandle,
    isBotConnected: _isBotConnected,
    widgetUIState: {
      keyboard: 'enable',
      agentTransfer: 'disable',
      attachment: 'hide'
    }
  };
}]);
"use strict";

function htmlAction(mId, chosen, actionType) {
  var choices = [];

  for (var i = 0; i < $('#' + mId + '_html .action').find('div').length; i++) {
    if ($($('#' + mId + '_html .action').find('div')[i]).attr('prop') != chosen) {
      $($('#' + mId + '_html .action').find('div')[i]).hide();
    } else {
      $($('#' + mId + '_html .action').find('div')[i]).addClass('selected');
    }

    $($('#' + mId + '_html .action').find('div')[i]).removeAttr("onclick");
    choices.push($($('#' + mId + '_html .action').find('div')[i]).attr('prop'));
  }

  angular.element(document.getElementById('_ChatCntrl')).scope().htmlAction(mId, chosen, actionType, choices);
}
"use strict";

mtChatApp.factory('httpErrorFactory', ['$state', function ($state) {
  return {
    error401: function error401() {
      logger.error("Error 404");
    },
    error403: function error403() {
      logger.error("Error 403");
    }
  };
}]);
"use strict";

var loggerLevels = {
  "verbose": ["verbose", "debug", "error"],
  "debug": ["debug", "error"],
  "error": ["error"]
};
var logger = {
  error: function error(message) {
    message = "Time: " + moment().format("MMMM d, YYYY HH:mm:ss") + " : " + message;

    if (loggerLevels[window.loggerLevel].indexOf("error") > -1) {
      var ua = window.navigator.userAgent,
          msie = ua.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        console.error(message);
      } else {
        console.log("%c" + message, "color:#ff0000;font-size:12px;");
      }
    }
  },
  debug: function debug(message) {
    message = "Time: " + moment().format("MMMM d, YYYY HH:mm:ss") + " : " + message;

    if (loggerLevels[window.loggerLevel].indexOf("debug") > -1) {
      var ua = window.navigator.userAgent,
          msie = ua.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        console.log(message);
      } else {
        console.log("%c" + message, "color:#637394;font-size:12px;");
      }
    }
  },
  verbose: function verbose(message) {
    message = "Time: " + moment().format("MMMM d, YYYY HH:mm:ss") + " : " + message;

    if (loggerLevels[window.loggerLevel].indexOf("verbose") > -1) {
      var ua = window.navigator.userAgent,
          msie = ua.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        console.info(message);
      } else {
        console.log("%c" + message, "color:#aa7700;font-size:12px;");
      }
    }
  }
};
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

mtChatApp.service('mqttService', ['$http', '$rootScope', '$state', 'constant', 'utilFactory', 'utilService', 'dataService', 'textToSpeech', function ($http, $rootScope, $state, constant, utilFactory, utilService, dataService, textToSpeech) {
  var userInfo = {},
      mqtt = null,
      incomingChats = [],
      mqttUsername = "",
      clientMQTTTopicPrefix = "",
      mqttPassword = "",
      that = this,
      offTabMsgNotifier = new Audio(),
      inTabMsgNotifier = new Audio(),
      mqttCheckTimer = null,
      widgetIdleTimer = null,
      triggerWidgetIdelTime = null,
      chatEvent = [];
  var a8bot_sto = {
    botHandles: {}
  };
  this.isSendUserInfo = false;

  this.connectMQTTBroker = function () {
    logger.verbose("MQTT Connect Broker");

    if (localStorage.a8bot_sto) {
      a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    }

    inTabMsgNotifier.src = dataService.userInfo.domainURL + '/audio/tone_new.mp3';
    offTabMsgNotifier.src = dataService.userInfo.domainURL + '/audio/tone.mp3';
    dataService.deviceInfo = utilFactory.getUserDeviceInfo();

    if (!a8bot_sto.botHandles[dataService.botHandle].clientId) {
      logger.verbose("Client id not generated");
      return;
    }

    mqttUsername = 'org-' + dataService.userInfo.orgId;
    mqttPassword = dataService.userInfo.appKey;
    clientMQTTTopicPrefix = "orgs-" + dataService.userInfo.orgId + "/clients/" + a8bot_sto.botHandles[dataService.botHandle].clientId;
    var urlParser = document.createElement('a');
    urlParser.href = window.baseURL;
    var isSSLEnable = urlParser.protocol == "https:" ? true : false;
    var hostName = urlParser.hostname;
    var portNo = urlParser.protocol == "https:" ? 443 : 80;

    if (urlParser.port) {
      portNo = urlParser.port;
    } // Create a client instance


    mqtt = new Paho.MQTT.Client(hostName, parseInt(portNo.toString()), dataService.mqttClientId); // set callback handlers

    mqtt.onConnectionLost = this.onConnectionLost;
    mqtt.onMessageArrived = this.onMessageArrived; //set will lost message

    var willMsg = new Paho.MQTT.Message("offline");
    willMsg.qos = 1;
    willMsg.destinationName = clientMQTTTopicPrefix + "/status"; // connect the client

    mqtt.connect({
      useSSL: isSSLEnable,
      onSuccess: this.onConnect,
      onFailure: function onFailure(data) {
        logger.error("MQTT Connect Failure: " + data.errorMessage);
      },
      userName: mqttUsername,
      password: mqttPassword,
      willMessage: willMsg
    });
  };

  this.onConnectionLost = function (responseObject) {
    // console.log(responseObject)
    dataService.chat.status = "Offline";
    $rootScope.$broadcast('connectionStatus');
    logger.verbose("MQTT Client Offline: " + utilFactory.toCustomDateTimeFormat(new Date().getTime()));
  };

  this.onConnect = function () {
    logger.verbose("MQTT Connected: " + utilFactory.toCustomDateTimeFormat(new Date().getTime()));

    if (localStorage.a8bot_sto) {
      a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    } //Set Agent State to Online


    var message = new Paho.MQTT.Message("online");
    message.destinationName = clientMQTTTopicPrefix + "/status";
    mqtt.send(message); //Subscribe

    mqtt.subscribe(clientMQTTTopicPrefix + "/#"); //that.retainedChats();

    if (mqttCheckTimer) {
      clearInterval(mqttCheckTimer);
    }

    mqttCheckTimer = setInterval(function () {
      if (mqtt.isConnected() == false) {
        logger.verbose("MQTT Disconnected: " + utilFactory.toCustomDateTimeFormat(new Date().getTime()));
        that.connectMQTTBroker();
      }
    }, 5000);
    dataService.chat.status = "Online";
    $rootScope.$broadcast('connectionStatus');
    triggerWidgetIdelTime = 1;

    if (constant.configuration && constant.configuration.idleTimeEvent) {
      triggerWidgetIdelTime = constant.configuration.idleTimeEvent;
    }

    that.triggerWidgetIdel();
  };

  this.mqttDisconnect = function () {
    if (mqttCheckTimer) {
      clearInterval(mqttCheckTimer);
    }

    if (mqtt) {
      mqtt.disconnect();
    }
  };

  this.requestChat = function (eventName) {
    logger.verbose("MQTT Chat Request");

    if (localStorage.a8bot_sto) {
      a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    }

    if (chatEvent.indexOf(eventName) == -1) {
      chatEvent.push(eventName);
    }

    var msg = null;
    dataService.chat.msg = [];

    if (a8bot_sto.botHandles[dataService.botHandle].selectedTopics) {
      var selectedTopics = that.getSelectedTopics();

      if (selectedTopics[selectedTopics.current].status == null) {
        selectedTopics[selectedTopics.current].status = "Initiated";
        a8bot_sto.botHandles[dataService.botHandle].selectedTopics = selectedTopics;
        dataService.chat.msg = [];
        that.sendChatPreflightEvent(eventName, {});
      } else {
        // msg = utilFactory.getValueFromStore(selectedTopics[selectedTopics.current].chatId, constant.Type.Object);
        // msg = a8bot_sto.botHandles[dataService.botHandle][selectedTopics[selectedTopics.current].chatId];
        // if (msg) {
        //     dataService.chat.msg = msg;
        // }
        logger.verbose("Chat Status: " + selectedTopics[selectedTopics.current].status + " :Topic: " + selectedTopics[selectedTopics.current].label);
      }

      $rootScope.$broadcast('onMessageUpdate', {
        "action": "New"
      });
    }
  };

  this.onChatRequestRec = function (data, broadcast) {
    logger.verbose("MQTT Chat Request Rec: " + data.body.chatId);
    var selectedTopics = that.getSelectedTopics();

    if (selectedTopics[selectedTopics.current].requestId == data.requestId) {
      selectedTopics[selectedTopics.current].chatId = data.body.chatId;
      selectedTopics[selectedTopics.current].status = "STARTED";
      dataService.isBotConnected = true;
    }

    a8bot_sto.botHandles[dataService.botHandle].selectedTopics = selectedTopics;
    this.updateStorage();
    parent.postMessage({
      type: 'lStorage',
      selectedTopics: a8bot_sto.botHandles[dataService.botHandle].selectedTopics
    }, dataService.hostedURL);

    if (a8bot_sto.botHandles[dataService.botHandle].msgInQueue) {
      var msg = a8bot_sto.botHandles[dataService.botHandle].msgInQueue;
      this.sendMsg(msg);
    }

    if (chatEvent.length > 0) {
      this.sendChatEvent(chatEvent[0], {});
    }
  };

  this.transferToAgent = function () {
    this.sendChatEvent("chatWidget.onTransferToAgent", {});
  };

  this.sendTypeSenseText = function (clientMsgTxt) {
    if (clientMsgTxt) {
      if (a8bot_sto.botHandles[dataService.botHandle].selectedTopics) {
        var selectedTopics = that.getSelectedTopics();
        logger.verbose("MQTT Send Type Sense Preview: " + clientMsgTxt);

        if (selectedTopics[selectedTopics.current].chatId) {
          var payload = {
            "id": new Date().getTime(),
            "chatId": selectedTopics[selectedTopics.current].chatId,
            "fromId": "u/" + a8bot_sto.botHandles[dataService.botHandle].clientId,
            "fromName": dataService.userInfo.displayName ? dataService.userInfo.displayName : "You",
            "msgType": "text",
            "msg": {
              "text": clientMsgTxt
            }
          };
          var message = new Paho.MQTT.Message(JSON.stringify(payload));
          message.destinationName = "orgs-" + dataService.userInfo.orgId + "/clients/" + a8bot_sto.botHandles[dataService.botHandle].clientId + "/typesense";
          mqtt.send(message);
        }
      }
    }
  };

  this.newChatRequest = function (selectedTopics, cEvent) {
    if (cEvent && chatEvent.indexOf(cEvent) == -1) {
      chatEvent.push(cEvent);
    }

    var userInfo = JSON.parse(JSON.stringify(dataService.userInfo));
    delete userInfo.appKey;
    var requestChatInfo = {
      id: selectedTopics[selectedTopics.current].requestId,
      uri: "newChat",
      body: {
        topicId: selectedTopics.current,
        botHandle: dataService.userInfo.botHandle,
        fromId: "u/" + a8bot_sto.botHandles[dataService.botHandle].clientId,
        fromName: dataService.userInfo.displayName ? dataService.userInfo.displayName : "You",
        deviceInfo: dataService.deviceInfo,
        email: userInfo.email,
        userInfo: userInfo
      }
    };
    logger.verbose("MQTT New Chat Request: " + JSON.stringify(requestChatInfo));
    var message = new Paho.MQTT.Message(JSON.stringify(requestChatInfo));
    message.destinationName = clientMQTTTopicPrefix + "/request";
    mqtt.send(message);
  };

  this.sendMsg = function (data) {
    if (a8bot_sto.botHandles[dataService.botHandle].selectedTopics) {
      var selectedTopics = that.getSelectedTopics();
      this.triggerWidgetIdel();

      if (selectedTopics[selectedTopics.current].status == null) {
        logger.verbose("MQTT Send Msg Calling Request Chat");
        a8bot_sto.botHandles[dataService.botHandle].msgInQueue = data;
        this.newChatRequest(selectedTopics);
      } else {
        var selectedTopics = a8bot_sto.botHandles[dataService.botHandle].selectedTopics;
        logger.debug("MQTT Send Msg: " + JSON.stringify(data));
        var payload = "";

        if (!utilFactory.isNullEmptyUndefined(selectedTopics[selectedTopics.current].chatId)) {
          that.updateTopicLastMsg(selectedTopics[selectedTopics.current].chatId, data);
          payload = {
            id: data.id,
            chatId: selectedTopics[selectedTopics.current].chatId,
            fromId: "u/" + a8bot_sto.botHandles[dataService.botHandle].clientId,
            fromName: dataService.userInfo.displayName ? dataService.userInfo.displayName : "You",
            msgType: data.msgType,
            msg: data.msg,
            sentAt: new Date().getTime()
          };
          logger.debug("MQTT Send Payload: " + JSON.stringify(payload));
          var message = new Paho.MQTT.Message(JSON.stringify(payload));
          message.destinationName = clientMQTTTopicPrefix + "/outbox";
          mqtt.send(message);
        }
      }
    }
  };

  this.sendMetaUserInfo = function () {
    if (!dataService || !dataService.userMetaInfo) {
      return;
    }

    logger.verbose("MQTT Send User Info Payload: " + JSON.stringify(dataService.userMetaInfo));

    if (a8bot_sto.botHandles[dataService.botHandle].selectedTopics) {
      var selectedTopics = that.getSelectedTopics();

      if (selectedTopics.current && selectedTopics[selectedTopics.current].chatId) {
        dataService.userMetaInfo.chatId = selectedTopics[selectedTopics.current].chatId;
      }
    }

    var payload = {
      metainfo: dataService.userMetaInfo
    };
    var message = new Paho.MQTT.Message(JSON.stringify(payload));
    message.destinationName = "orgs-" + dataService.userMetaInfo.orgId + "/clients/" + a8bot_sto.botHandles[dataService.botHandle].clientId + "/clientstream";
    mqtt.send(message);
    logger.debug("MQTT Sent Send User Info MSG: " + JSON.stringify(message));
  };

  this.sendChatEvent = function (eventName, payload) {
    logger.verbose("MQTT send chat Event");

    if (!dataService || !dataService.userInfo.orgId) {
      return;
    }

    var selectedTopics = that.getSelectedTopics();

    if (selectedTopics) {
      if (selectedTopics[selectedTopics.current].status == null) {
        if (chatEvent.indexOf(eventName) == -1) {
          chatEvent.push(eventName);
        }

        selectedTopics[selectedTopics.current].status = "Initiated";
        a8bot_sto.botHandles[dataService.botHandle].selectedTopics = selectedTopics;
        dataService.chat.msg = [];
        that.newChatRequest(selectedTopics);
      } else if (selectedTopics[selectedTopics.current].status == "STARTED") {
        var data = {
          "type": "event",
          "event": eventName,
          "botHandle": dataService.userInfo.botHandle,
          "chatId": selectedTopics[selectedTopics.current].chatId,
          "fromId": "u/" + a8bot_sto.botHandles[dataService.botHandle].clientId,
          "fromName": dataService.userInfo.displayName ? dataService.userInfo.displayName : "You",
          "payload": payload,
          "createdAt": new Date().toISOString(),
          "clientId": a8bot_sto.botHandles[dataService.botHandle].clientId
        };
        var message = new Paho.MQTT.Message(JSON.stringify(data));
        message.destinationName = "orgs-" + dataService.userInfo.orgId + "/clients/" + a8bot_sto.botHandles[dataService.botHandle].clientId + "/clientstream";
        mqtt.send(message);
        logger.verbose("MQTT Sent Chat Event MSG: " + JSON.stringify(message));

        if (chatEvent.indexOf(eventName) != -1) {
          chatEvent.splice(chatEvent.indexOf(eventName, 1));
        }

        if (chatEvent.length > 0) {
          that.sendChatPreflightEvent(chatEvent[0], {});
        }
      }
    }
  };

  this.sendChatPreflightEvent = function (eventName, payload) {
    if (!dataService || !dataService.userInfo || document.hidden == true && eventName != "chatWidget.onLoad") {
      return;
    }

    var data = {
      "type": "preflightEvent",
      "event": eventName,
      "payload": payload,
      "botHandle": dataService.userInfo.botHandle,
      "fromId": "u/" + a8bot_sto.botHandles[dataService.botHandle].clientId,
      "clientId": a8bot_sto.botHandles[dataService.botHandle].clientId,
      "createdAt": new Date().toISOString()
    };
    var message = new Paho.MQTT.Message(JSON.stringify(data));
    message.destinationName = "orgs-" + dataService.userInfo.orgId + "/clients/" + a8bot_sto.botHandles[dataService.botHandle].clientId + "/clientstream";
    mqtt.send(message);
    logger.debug("MQTT Sent Chat Preflight Event: " + JSON.stringify(message));
  };

  this.updateTopicLastMsg = function (chatId, data) {
    var selectedTopics = that.getSelectedTopics(); //JSON.parse(a8bot_sto.botHandles[dataService.botHandle].selectedTopics);

    for (var tp in selectedTopics) {
      if (selectedTopics[tp].chatId == chatId) {
        if (data.msgType == 'text') {
          selectedTopics[tp].lastMsg = data.msg.text;
        } else {
          selectedTopics[tp].lastMsg = '<p><img class="attach" src="../../images/attach.svg"/>Attachment</p>';
        }
      }
    }

    a8bot_sto.botHandles[dataService.botHandle].selectedTopics = selectedTopics; // localStorage.a8bot_sto = JSON.stringify(a8bot_sto);

    that.updateStorage();
    parent.postMessage({
      type: 'lStorage',
      selectedTopics: a8bot_sto.botHandles[dataService.botHandle].selectedTopics
    }, dataService.hostedURL);
  };

  this.formatAgentMessage = function (msgObj, resp) {
    if (resp.text && msgObj) {
      msgObj.msgType = "text";
      msgObj.msg = {
        text: resp.text
      };
      return msgObj;
    }
  };

  this.onMessageArrived = function (message) {
    var selectedTopics = that.getSelectedTopics();
    var broadcast = true;

    if (message.destinationName.indexOf("/inbox") !== -1) {
      logger.debug("MQTT MSG Inbox: " + message.payloadString);
      var resp = JSON.parse(message.payloadString);

      if (document.hidden) {
        offTabMsgNotifier.play();
      } else if (dataService.tabStatus == "Close") {
        inTabMsgNotifier.play();
      }

      var data = {
        id: resp.id ? resp.id : utilFactory.generateMsgId(),
        mId: resp.mId,
        fromName: resp.fromName,
        timestamp: resp.sentAt,
        dateTimeFormatted: utilFactory.toCustomDateTimeFormat(new Date(new Date(resp.sentAt).getTime())),
        getFeedback: false,
        msgType: resp.msgType ? resp.msgType : null,
        msg: resp.msg ? resp.msg : null,
        from: {
          userId: resp.fromId
        }
      };

      if (data.msg == null) {
        data = that.formatAgentMessage(data, resp.msg);
      }

      if (resp.chatId && !a8bot_sto.botHandles[dataService.botHandle][resp.chatId]) {
        a8bot_sto.botHandles[dataService.botHandle][resp.chatId] = [];
      }

      if (selectedTopics[selectedTopics.current].chatId != resp.chatId || dataService.tabStatus == '' || dataService.tabStatus == 'Close') {
        if (a8bot_sto.botHandles[dataService.botHandle][resp.chatId]) {
          dataService.chat.msg.push(data);
          that.updateTopicLastMsg(resp.chatId, data);

          if (dataService.tabStatus == '' || dataService.tabStatus == 'Close') {
            $rootScope.$broadcast('onMsgNotification', data);
          } else {
            $rootScope.$broadcast('onMessageUpdate', {
              "action": "Inbox"
            });
          }
        }
      } else {
        if (dataService.chat.msg.length > 0 && dataService.chat.msg[dataService.chat.msg.length - 1].isUserTyping == "STARTED") {
          dataService.chat.msg.splice(dataService.chat.msg.length - 1, 0, data);
        } else {
          that.addOrUpdateMsg(data);

          if (data.from.userId.indexOf("a/") !== -1 && constant.configuration.textToSpeech) {
            var text = "";
            var choices = null;

            if (data.msgType == "text") {
              text = data.msg.text;
            } else if (data.msgType == "simpleChoice") {
              text = data.msg.msg.text;
              choices = data.msg.msg.choices;
            }

            textToSpeech.playText({
              text: text,
              choices: choices
            });
          }
        }

        that.updateTopicLastMsg(selectedTopics[selectedTopics.current].chatId, data);
        $rootScope.$broadcast('onMessageUpdate', {
          "action": "New"
        });
      }
    } else if (message.destinationName.indexOf("/response") !== -1) {
      var receivedPayload = JSON.parse(message.payloadString);
      that.onChatRequestRec(receivedPayload, broadcast);
    } else if (message.destinationName.indexOf("/directstream") !== -1) {
      logger.debug("MQTT Directstream: " + JSON.stringify(message.payloadString));

      if (message.payloadString) {
        var receivedPayload = JSON.parse(message.payloadString);

        if (receivedPayload.event == "widgetUIState") {
          a8bot_sto.botHandles[dataService.botHandle].selectedTopics[selectedTopics.current].widgetUIState = receivedPayload.data;
          parent.postMessage({
            type: 'lStorage',
            selectedTopics: a8bot_sto.botHandles[dataService.botHandle].selectedTopics
          }, dataService.hostedURL);
          that.updateStorage();
          $rootScope.$broadcast('onWidgetUIState', receivedPayload.data);
        } else if (receivedPayload.event == "botSuggestions") {
          $rootScope.$broadcast('onSuggestionUpdate', receivedPayload.data);
        } else if (receivedPayload.event == "typingIndicator") {
          $rootScope.$broadcast('onBotTypingEventStart', receivedPayload);
        } else if (receivedPayload.type == "preflightEvent") {
          var selectedTopics = null;

          if (a8bot_sto.botHandles[dataService.botHandle].selectedTopics) {
            selectedTopics = that.getSelectedTopics();
          }

          if (receivedPayload.hasMessage && selectedTopics) {
            if (selectedTopics[selectedTopics.current].status == "Initiated") {
              logger.verbose("MQTT Send Msg Calling Request Chat");
              that.newChatRequest(selectedTopics, receivedPayload.event);
            } else if (!selectedTopics[selectedTopics.current].status || selectedTopics[selectedTopics.current].status == "STARTED") {
              that.sendChatEvent(receivedPayload.event, {});
            }
          } else if (receivedPayload.hasMessage == false && selectedTopics && selectedTopics[selectedTopics.current].status != "STARTED") {
            if (chatEvent.indexOf(receivedPayload.event) != -1) {
              chatEvent.splice(chatEvent.indexOf(receivedPayload.event), 1);
            }

            selectedTopics[selectedTopics.current].status = null;
            a8bot_sto.botHandles[dataService.botHandle].selectedTopics = selectedTopics;
            that.updateStorage();
          }
        }
      }
    } else if (message.destinationName.indexOf("/events") !== -1) {
      that.topicEvents(message);
    } else {
      logger.verbose("Unhandled MQTT Resp: " + JSON.stringify(message));
    }
  };

  this.checkDuplicateMsg = function (data, array) {
    var isRender = true;
    angular.forEach(array, function (item, index) {
      if (item != null && item.id == data.id) {
        isRender = false;
      }
    });
    return isRender;
  };

  this.addOrUpdateMsg = function (data, array) {
    var isNew = true;
    angular.forEach(dataService.chat.msg, function (item, index) {
      if (item != null && item.id == data.id) {
        item.dateTimeFormatted = data.dateTimeFormatted;
        item.timestamp = data.timestamp;
        isNew = false;
      }
    });

    if (isNew) {
      dataService.chat.msg.push(data);
    }
  };

  this.topicEvents = function (message) {
    logger.verbose("MQTT Topic Events");
    var selectedTopics = that.getSelectedTopics();
    var payload = JSON.parse(message.payloadString),
        events = payload.events,
        broadcast = true;

    for (var i = 0; i < events.length; i++) {
      logger.verbose("MQTT Events: " + JSON.stringify(events[i]));

      if (events[i].name == "messageDelivered") {
        logger.verbose("MQTT MessageDelivered ");
        dataService.chat.msg.map(function (item) {
          if (item.id == events[i].params.id) {
            item.timestamp = events[i].createdAt;
            item.dateTimeFormatted = utilFactory.toCustomDateTimeFormat(new Date(new Date(events[i].createdAt).getTime()));
            item.mId = events[i].params.mId;
          }
        });
        logger.debug("MQTT Chat Msg Update: " + JSON.stringify(dataService.chat));
        $rootScope.$broadcast('onMessageUpdate', {
          "action": "New"
        });
      }
    }
  };

  this.triggerWidgetIdel = function () {
    if (widgetIdleTimer) {
      clearInterval(widgetIdleTimer);
    }

    if (triggerWidgetIdelTime) {
      widgetIdleTimer = setInterval(function () {
        that.sendChatPreflightEvent("chatWidget.onIdle", {});
        that.triggerWidgetIdel();
      }, triggerWidgetIdelTime * 60 * 1000);
    }
  };

  this.updateStorage = function () {
    localStorage.setItem('a8bot_sto', JSON.stringify(a8bot_sto));
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    $rootScope.$broadcast('onStorageUpdate', {
      'triggeredBy': 'MQTT'
    });
  };

  $rootScope.$on('onStorageUpdate', function (event, triggeredBy) {
    if (triggeredBy != "MQTT") {
      a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    }
  });

  this.getSelectedTopics = function () {
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);

    if (typeof a8bot_sto.botHandles[dataService.botHandle].selectedTopics == "string") {
      return JSON.parse(a8bot_sto.botHandles[dataServeice.botHandle].selectedTopics);
    } else if (_typeof(a8bot_sto.botHandles[dataService.botHandle].selectedTopics) == "object") {
      return a8bot_sto.botHandles[dataService.botHandle].selectedTopics;
    } else {
      return null;
    }
  };

  window.addEventListener('beforeunload', function (e) {
    mqtt.disconnect();
  });
}]);
"use strict";

mtChatApp.config(['$stateProvider', '$ocLazyLoadProvider', '$urlRouterProvider', function ($stateProvider, $ocLazyLoadProvider, $urlRouterProvider) {
  $stateProvider.state('chat', {
    url: 'chat',
    templateUrl: 'app/components/chat/chatView.html',
    resolve: {
      loadPlugin: ["$ocLazyLoad", function loadPlugin($ocLazyLoad) {
        return $ocLazyLoad.load([{
          files: ['css/chat.css', 'css/fab.css']
        }]);
      }]
    }
  });
}]).run(['$rootScope', '$urlRouter', '$state', function ($rootScope, $urlRouter, $state) {
  $rootScope.$on('$stateChangeStart', function (event, current) {//console.log("stateChangeStart");
  });
  $rootScope.$on('$locationChangeStart', function (evet, current) {//console.log("locationChangeStart");
  });
  $rootScope.$on('$locationChangeSuccess', function (event, current) {//console.log("locationChangeSuccess");
  });
}]);
"use strict";

mtChatApp.constant('svgFileObjects', {
  Thumbsdown: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" height="{height_code}" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"> <style type="text/css"> .{class_code_0}{fill:{fill_code_0}} </style> <g id="Unlike_Outer"> <g id="Like_48_"> <g> <g> <path class="{class_code_0}" d="M85,35.8c0-1.8-0.7-3.4-1.8-4.7c1.1-1.2,1.8-2.9,1.8-4.7c0-3.2-2.2-6-5.2-6.8c0.3-0.8,0.5-1.7,0.5-2.6 c0-3.9-3.1-7-7-7H53.8c-2.8,0-5.5,0.4-8.1,1.3l-8,2.7c-1.1-2.4-3.5-4-6.3-4h-14C16,10,15,11.1,15,12.3v42.2c0,1.3,1,2.3,2.3,2.3 h14c3,0,5.5-1.8,6.5-4.5c5.9,1.4,11.5,9.3,13.3,16.5l1.3,5.1c0.3,1,1.2,1.8,2.3,1.8H57c5.1,0,9.3-4.2,9.3-9.4V64 c0-2.3-0.6-7.8-1.9-11.9H78c3.9,0,7-3.2,7-7c0-1.8-0.7-3.4-1.8-4.7C84.3,39.2,85,37.6,85,35.8z M33.7,49.8c0,1.3-1,2.3-2.3,2.3 H19.7V14.7h11.7c1.3,0,2.3,1.1,2.3,2.3V49.8z M71,40.5c0,1.3,1,2.3,2.3,2.3H78c1.3,0,2.3,1.1,2.3,2.3s-1,2.3-2.3,2.3H54.7 c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3h4.8c1.3,2.7,2.2,8.7,2.2,11.9v2.3c0,2.6-2.1,4.7-4.7,4.7h-0.5l-0.8-3.3 c-1.1-4.5-3.7-9.5-6.8-13.2c-3.2-3.8-6.8-6.1-10.5-6.8v-29l8.8-3c2.1-0.7,4.4-1.1,6.6-1.1h19.5c1.3,0,2.3,1.1,2.3,2.3 s-1,2.3-2.3,2.3s-2.3,1-2.3,2.3s1,2.3,2.3,2.3H78c1.3,0,2.3,1.1,2.3,2.3c0,1.3-1,2.3-2.3,2.3h-4.7c-1.3,0-2.3,1-2.3,2.3 s1,2.3,2.3,2.3H78c1.3,0,2.3,1.1,2.3,2.3s-1,2.3-2.3,2.3h-4.7C72,38.1,71,39.2,71,40.5z"/> </g> </g> <g> <g> <path class="{class_code_0}" d="M61.7,87.7v-4.8c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3v4.8c0,1.3,1,2.3,2.3,2.3C60.6,90,61.7,89,61.7,87.7z" /> </g> </g> <g> <g> <path class="{class_code_0}" d="M49.4,76.3c-0.9-0.9-2.4-0.9-3.3,0l-3.3,3.3c-0.9,0.9-0.9,2.4,0,3.3s2.4,0.9,3.3,0l3.3-3.3 C50.3,78.7,50.3,77.3,49.4,76.3z"/> </g> </g> <g> <g> <path class="{class_code_0}" d="M75.8,79.7l-3.3-3.3c-0.9-0.9-2.4-0.9-3.3,0s-0.9,2.4,0,3.3l3.3,3.3c0.9,0.9,2.4,0.9,3.3,0 C76.7,82.1,76.7,80.6,75.8,79.7z"/> </g> </g> </g> </g> </svg> ',
  Thumbsup: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" height="{height_code}" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"> <style type="text/css"> .{class_code_0}{fill:{fill_code_0}} </style> <g id="Like_Outer"> <g id="Like_47_"> <g> <g> <path class="{class_code_0}" d="M83.2,59.5c1.1-1.2,1.8-2.9,1.8-4.7c0-3.9-3.1-7-7-7H64.4c1.3-4.1,1.9-9.5,1.9-11.9v-2.3 c0-5.2-4.2-9.4-9.3-9.4h-2.3c-1.1,0-2,0.7-2.3,1.8l-1.3,5.1c-1.8,7.2-7.4,15-13.3,16.5c-1-2.6-3.6-4.5-6.5-4.5h-14 c-1.3,0-2.3,1-2.3,2.3v42.2c0,1.3,1,2.3,2.3,2.3h14c2.8,0,5.2-1.6,6.3-4l8,2.7c2.6,0.9,5.4,1.3,8.1,1.3h19.5c3.9,0,7-3.2,7-7 c0-0.9-0.2-1.8-0.5-2.6c3-0.8,5.2-3.5,5.2-6.8c0-1.8-0.7-3.4-1.8-4.7c1.1-1.2,1.8-2.9,1.8-4.7S84.3,60.8,83.2,59.5z M33.7,83 c0,1.3-1,2.3-2.3,2.3H19.7V47.8h11.7c1.3,0,2.3,1.1,2.3,2.3V83z M73.3,61.9H78c1.3,0,2.3,1.1,2.3,2.3c0,1.3-1,2.3-2.3,2.3h-4.7 c-1.3,0-2.3,1.1-2.3,2.3s1,2.3,2.3,2.3H78c1.3,0,2.3,1.1,2.3,2.3s-1,2.3-2.3,2.3h-4.7C72,75.9,71,77,71,78.3s1,2.3,2.3,2.3 s2.3,1.1,2.3,2.3s-1,2.3-2.3,2.3H53.8c-2.3,0-4.5-0.4-6.6-1.1l-8.8-3v-29c3.7-0.7,7.2-3,10.5-6.8c3.2-3.7,5.7-8.7,6.8-13.2 l0.8-3.3H57c2.6,0,4.7,2.1,4.7,4.7v2.3c0,3.1-1,9.2-2.2,11.9h-4.8c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3H78c1.3,0,2.3,1.1,2.3,2.3 s-1,2.3-2.3,2.3h-4.7c-1.3,0-2.3,1-2.3,2.3S72,61.9,73.3,61.9z"/> </g> </g> <g> <g> <path class="{class_code_0}" d="M59.3,10C58,10,57,11,57,12.3v4.8c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3v-4.8C61.7,11,60.6,10,59.3,10z"/> </g> </g> <g> <g> <path class="{class_code_0}" d="M49.4,20.3L46.1,17c-0.9-0.9-2.4-0.9-3.3,0c-0.9,0.9-0.9,2.4,0,3.3l3.3,3.3c0.9,0.9,2.4,0.9,3.3,0 C50.3,22.7,50.3,21.3,49.4,20.3z"/> </g> </g> <g> <g> <path class="{class_code_0}" d="M75.8,17c-0.9-0.9-2.4-0.9-3.3,0l-3.3,3.3c-0.9,0.9-0.9,2.4,0,3.3s2.4,0.9,3.3,0l3.3-3.3 C76.7,19.4,76.7,17.9,75.8,17z"/> </g> </g> </g> </g> </svg> ',
  FillThumbsdown: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><defs><style>.cls-1{fill:#fedbab;}.cls-2{fill:#fec478;}.{class_code_0}{fill:{fill_code_0}}.cls-4{fill:#fff;}</style></defs><title>fill unlike button</title><g id="Like"><path class="cls-1" d="M51.81,21.72A2.59,2.59,0,0,1,50,24.9a2.58,2.58,0,1,1,1.39,5L41.23,32.7a22.94,22.94,0,0,1,4,8.44,3.87,3.87,0,0,1-1.51,4.2,3.59,3.59,0,0,1-1.18.57l-.74.2a1.33,1.33,0,0,1-1.46-.61L38.85,43c-2.17-3.76-6.89-7.7-11-6.55L23,19.06l5-3.38a12.69,12.69,0,0,1,3.75-1.74l11.64-3.25a2.58,2.58,0,1,1,1.39,5l2.48-.7a2.58,2.58,0,1,1,1.39,5A2.58,2.58,0,0,1,51.81,21.72Z"/><path class="cls-2" d="M43.38,10.69a2.58,2.58,0,1,1,1.39,5l2.48-.7a2.58,2.58,0,1,1,1.39,5,2.58,2.58,0,0,1,1.38,5,2.58,2.58,0,1,1,1.39,5L41.23,32.7a22.94,22.94,0,0,1,4,8.44,3.87,3.87,0,0,1-1.51,4.2,3.59,3.59,0,0,1-1.18.57l-9-32.45Z"/><path class="{class_code_0}" d="M19.1,14.79l-7.45,2.08a1.27,1.27,0,0,0-.89,1.58L17,40.8a1.29,1.29,0,0,0,1.59.9L26,39.62a3.86,3.86,0,0,0,2.68-4.76L23.86,17.47A3.86,3.86,0,0,0,19.1,14.79Z"/><circle class="cls-4" cx="18.35" cy="21.69" r="1.29"/><path class="{class_code_0}" d="M45.48,51.77l-.7-2.48A1.29,1.29,0,1,0,42.3,50L43,52.46a1.29,1.29,0,1,0,2.49-.69Z"/><path class="{class_code_0}" d="M35.56,48.17,34.3,50.41a1.29,1.29,0,1,0,2.24,1.27l1.27-2.25a1.29,1.29,0,0,0-2.25-1.26Z"/><path class="{class_code_0}" d="M47.85,44.74a1.28,1.28,0,0,0,.49,1.75l2.25,1.27a1.29,1.29,0,1,0,1.27-2.24l-2.25-1.27A1.29,1.29,0,0,0,47.85,44.74Z"/></g></svg>',
  FillThumbsup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><defs><style>.cls-1{fill:#fedbab;}.cls-2{fill:#fec478;}.{class_code_0}{fill:{fill_code_0}}.cls-4{fill:#fff;}</style></defs><title>like button</title><g id="Like"><path class="cls-1" d="M51.22,32.09a2.57,2.57,0,0,0-3.11-1.89,2.58,2.58,0,0,0-1.22-5l-10.27,2.5a22.94,22.94,0,0,0-.67-9.3,3.86,3.86,0,0,0-3.37-2.92,3.65,3.65,0,0,0-1.31.08l-.75.18a1.35,1.35,0,0,0-1,1.25l0,2.9C29.46,24.22,27.28,30,23.1,31l4.27,17.54,6,.49a13,13,0,0,0,4.12-.31l11.75-2.86a2.58,2.58,0,0,0-1.22-5l2.5-.61a2.58,2.58,0,1,0-1.22-5A2.58,2.58,0,0,0,51.22,32.09Z"/><path class="cls-2" d="M49.27,45.84a2.58,2.58,0,0,0-1.22-5l2.5-.61a2.58,2.58,0,1,0-1.22-5,2.58,2.58,0,0,0-1.22-5,2.58,2.58,0,0,0-1.22-5l-10.27,2.5a22.94,22.94,0,0,0-.67-9.3,3.86,3.86,0,0,0-3.37-2.92,3.65,3.65,0,0,0-1.31.08l8,32.73Z"/><path class="{class_code_0}" d="M26.08,54.14,18.57,56A1.29,1.29,0,0,1,17,55L11.52,32.48a1.29,1.29,0,0,1,1-1.56L20,29.09a3.87,3.87,0,0,1,4.67,2.84l4.27,17.53A3.87,3.87,0,0,1,26.08,54.14Z"/><circle class="cls-4" cx="22.05" cy="48.49" r="1.29"/><path class="{class_code_0}" d="M31,9l.61,2.51a1.29,1.29,0,0,1-2.5.61L28.5,9.59A1.29,1.29,0,1,1,31,9Z"/><path class="{class_code_0}" d="M24.12,17l-2.21-1.34a1.29,1.29,0,0,1,1.34-2.2l2.21,1.34A1.29,1.29,0,0,1,24.12,17Z"/><path class="{class_code_0}" d="M36.51,14a1.29,1.29,0,0,1-.43-1.77L37.42,10a1.29,1.29,0,1,1,2.21,1.34l-1.34,2.2A1.3,1.3,0,0,1,36.51,14Z"/></g></svg>'
});
"use strict";

mtChatApp.factory("textToSpeech", ["$rootScope", "$timeout", "utilService", "$sce", "constant", function ($rootScope, $timeout, utilService, $sce, constant) {
  return {
    authorization: null,
    config: {
      gender: 'Female',
      lang: 'en-US',
      name: 'en-CA-Linda'
    },
    init: function init() {
      this.config = {
        gender: constant.configuration.textToSpeech.gender ? constant.configuration.textToSpeech.gender : 'Female',
        lang: constant.configuration.textToSpeech.lang ? constant.configuration.textToSpeech.lang : 'en-US',
        name: constant.configuration.textToSpeech.name ? constant.configuration.textToSpeech.name : 'en-CA-Linda'
      };

      if (!localStorage.authorization) {
        this.handleRefreshToken();
      } else {
        this.authorization = localStorage.authorization;
      }
    },
    playText: function playText(data) {
      var payload = "";
      var content = "";
      var that = this;

      if (data.text) {
        payload = payload + "<voice xml:lang='" + this.config.lang + "' xml:gender='" + this.config.gender + "' name='" + this.config.name + "'>" + data.text + "</voice>";

        if (data.choices) {
          payload = payload + "<voice xml:lang='" + this.config.lang + "' xml:gender='" + this.config.gender + "' name='" + this.config.name + "'> Here are the options </voice>";

          for (var i in data.choices) {
            payload = payload + "<voice xml:lang='" + this.config.lang + "' xml:gender='" + this.config.gender + "' name='" + this.config.name + "'>" + data.choices[i].label + "</voice>";
          }
        }

        content = "<speak version='1.0' xml:lang='" + this.config.lang + "'>" + payload + "</speak>";
        logger.verbose("Final content: " + content);
        var httpConfig = {
          "url": config.ttsUrl,
          "method": "POST",
          "data": content,
          "responseType": "blob",
          "headers": {
            "Authorization": "Bearer " + this.authorization,
            "X-Microsoft-OutputFormat": config.audioOutputFormat,
            "Content-Type": 'application/ssml+xml'
          },
          "successCallback": function successCallback(status, data, headers) {
            if (data) {
              var audio = window.URL.createObjectURL(data);
              $rootScope.$broadcast('onPlayAudio', audio);
            }
          },
          "failureCallback": function failureCallback(status, data) {
            console.error("Play Text: ", status, data);

            if (status == 415) {
              console.error("TTS Unsupported media type");
            } else if (status == 401) {
              that.handleRefreshToken();
            }
          }
        };
        utilService.httpService(httpConfig);
      } else {
        logger.verbose("There is no text to speech");
      }
    },
    handleRefreshToken: function handleRefreshToken() {
      logger.verbose("I am running on time interval");
      var that = this;
      var httpConfig = {
        "url": config.ttsTokenUrl,
        "method": "POST",
        "headers": {
          "Ocp-Apim-Subscription-Key": config.subscriptionKey
        },
        "successCallback": function successCallback(status, data, headers) {
          // console.log("TTS Token: ", data)
          if (data) {
            that.authorization = data;
          }

          $timeout(function () {
            that.handleRefreshToken();
          }, 60000);
        },
        "failureCallback": function failureCallback(status, data) {
          console.error("Refresh Token: ", status, data);
          $timeout(function () {
            that.handleRefreshToken();
          }, 60000);
        }
      };
      utilService.httpService(httpConfig);
    }
  };
}]);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

mtChatApp.factory("utilFactory", ["$rootScope", "$state", "notify", "$modal", "constant", function ($rootScope, $state, notify, $modal, constant) {
  return {
    isSessionIDCookieAvailable: function isSessionIDCookieAvailable(text) {
      var name = constant.cookieName + "=";
      var ca = document.cookie.split(";");

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }

        if (c.indexOf(name) != -1) return true;
      }

      return false;
    },
    setCookie: function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires;
    },
    getValueFromStore: function getValueFromStore(key, type) {
      var value = "";
      value = this.isNullEmptyUndefined(localStorage['A8_' + key]) ? null : localStorage['A8_' + key];

      if (value != null) {
        if (type === constant.Type.Object) {
          return JSON.parse(value);
        } else if (type === constant.Type.Integer) {
          return parseInt(value);
        } else if (type === constant.Type.Float) {
          return parseFloat(value);
        } else {
          return value;
        }
      }
    },
    addAppId: function addAppId(url) {
      if (url.indexOf("?") !== -1) {
        return url + "&appId=" + $rootScope.selectedApp["_id"]; // return url+"&appId="+"593e43d98e90fc2a459d1f84"
      } else {
        // return url+"?appId="+$rootScope.appId
        return url + "?appId=" + $rootScope.selectedApp["_id"];
      }
    },
    addOrgId: function addOrgId(url) {
      if (url.indexOf("?") !== -1) {
        // return url+"&appId="+$rootScope.appId
        return url + "&orgId=" + localStorage["orgId"];
      } else {
        // return url+"?appId="+$rootScope.appId
        return url + "?orgId=" + localStorage["orgId"];
      }
    },
    setValueToStore: function setValueToStore(key, value) {
      if (!key) {
        return;
      }

      var pStatus = false;
      var message = "";

      try {
        if (_typeof(value) === constant.Type.Object) {
          value = JSON.stringify(value);
        }

        localStorage['A8_' + key] = value;
        pStatus = true;
        message = key, "successfully save to store";
      } catch (e) {
        message = e;
      }

      return {
        pStatus: pStatus,
        message: message
      };
    },
    isNotNullOrUndefinedString: function isNotNullOrUndefinedString(data) {
      if (data === undefined || data === null || $.trim(data) === "" || data === "undefined" || data === "null" || data.length == 0) {
        return false;
      }

      return true;
    },
    isNullEmptyUndefined: function isNullEmptyUndefined(value) {
      if ($.trim(value) === "" || value === undefined || value === "undefined" || value === null) {
        return true;
      }

      return false;
    },
    clearSession: function clearSession() {
      // console.log("-------------------------")
      // console.log(localStorage)
      // console.log(sessionStorage)
      // localStorage.clear();
      // sessionStorage.clear();
      for (var i = 0; i < localStorage.length; i++) {
        logger.verbose(localStorage.key(i));

        if (localStorage.key(i).substring(0, 3) == 'A8_') {
          localStorage.removeItem(localStorage.key(i));
        }
      }

      localStorage.setItem('msgId', 0);
      delete sessionStorage.selectedTopics;
    },
    triggerNotify: function triggerNotify(msg, msgType, template) {
      notify.closeAll();
      notify({
        message: msg,
        classes: msgType,
        templateUrl: template
      });
    },
    tiggerModal: function tiggerModal(modalConfig) {
      var modalInstance = $modal.open({
        templateUrl: modalConfig.templateUrl,
        windowClass: "animated flipInY",
        controller: ["$scope", function ($scope) {
          $scope.modalConfig = modalConfig;
        }]
      });
      return modalInstance;
    },
    colorGenerator: function colorGenerator() {
      return "#" + "0123456789abcdef".split("").map(function (v, i, a) {
        return i > 5 ? null : a[Math.floor(Math.random() * 16)];
      }).join("");
    },
    fieldValidation: function fieldValidation(fieldType, data) {
      var emailValidation = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var phonenoValidation = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i;
      var websiteValidation = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
      var validate = "";

      switch (fieldType) {
        case "WEB":
          validate = websiteValidation.test(data);
          break;

        case "EMAIL":
          validate = emailValidation.test(data);
          break;

        case "PHONE":
          validate = phonenoValidation.test(data);
          break;
      }

      return validate;
    },
    setBreadcrumb: function setBreadcrumb(current) {
      $rootScope.$broadcast("breadcrumbEvent", {
        breadcrumb: current
      });
    },
    generateUniqueId: function generateUniqueId(prefix) {
      function rand() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }

      return prefix + "_" + rand() + rand() + "-" + rand() + "-" + rand();
    },
    generateMsgId: function generateMsgId() {
      var id = localStorage["msgId"];

      if (id) {
        id = parseInt(id);
        id++;
      } else {
        id = 1;
      }

      localStorage["msgId"] = id; // console.log("Msg Id Created: ", localStorage.msgId);

      return id;
    },
    formQueryString: function formQueryString(map) {
      var queryString = "",
          key = "";

      for (key in map) {
        if (map.hasOwnProperty(key)) {
          if (queryString !== "") {
            queryString += "&";
          }

          queryString += key + "=" + encodeURIComponent(map[key]);
        }
      }

      return queryString === "" ? queryString : "?" + queryString;
    },
    toDateTimeString: function toDateTimeString(date) {
      date = date || new Date();
      var pattern = "hh:mm tt",
          HH = date.getHours(),
          mm = date.getMinutes(),
          ampm = HH > 11 ? "PM" : "AM",
          hh = HH % 12;
      hh = hh ? hh : 12;
      return this.toShortDateString(date) + " " + pattern.replace("hh", this.twoDigitText(hh)).replace("mm", this.twoDigitText(mm)).replace("tt", ampm);
    },
    toTimeString: function toTimeString(date) {
      date = date || new Date();
      var pattern = "hh:mm tt",
          HH = date.getHours(),
          mm = date.getMinutes(),
          ampm = HH > 11 ? "PM" : "AM",
          hh = HH % 12;
      hh = hh ? hh : 12;
      return pattern.replace("hh", this.twoDigitText(hh)).replace("mm", this.twoDigitText(mm)).replace("tt", ampm);
    },
    twoDigitText: function twoDigitText(number) {
      return (number < 10 ? "0" : "") + number;
    },
    toShortDateString: function toShortDateString(date) {
      date = date || new Date();
      var pattern = "MM/dd/yyyy";
      return pattern.replace("yyyy", date.getFullYear()).replace("dd", this.twoDigitText(date.getDate())).replace("MM", this.twoDigitText(date.getMonth() + 1));
    },
    toCustomDateTimeFormat: function toCustomDateTimeFormat(timeStamp) {
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      if (timeStamp != null) {
        var msgDate = new Date(timeStamp);
        var today = new Date();

        if (today.toDateString() == msgDate.toDateString()) {
          var time = msgDate.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true
          });
          return time;
        } else {
          var _time = msgDate.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true
          });

          var month = monthNames[msgDate.getMonth()];
          var day = msgDate.getUTCDate();
          var dateFormat = constant.botTheme && constant.botTheme.global && constant.botTheme.global.chatMsgDateFormat ? constant.botTheme.global.chatMsgDateFormat : "mm/dd";

          if (dateFormat == "mm/dd") {
            return month + " " + day + " " + _time;
          } else if (dateFormat == "dd/mm") {
            return day + " " + month + " " + _time;
          }
        }
      }
    },
    getUserDeviceInfo: function getUserDeviceInfo() {
      var os = "Unknown OS";
      var channel = navigator.appCodeName ? "Web" : "Unknown";
      var domain = window.location.href;
      var objappVersion = navigator.appVersion;
      var objAgent = navigator.userAgent;
      var channelName = navigator.appName;
      var objfullVersion = "" + parseFloat(objappVersion);
      var objBrMajorVersion = parseInt(objappVersion, 10);
      var objOffsetName, objOffsetVersion, ix;
      if (objappVersion.indexOf("Win") != -1) os = "Windows";
      if (objappVersion.indexOf("Mac") != -1) os = "MacOS";
      if (objappVersion.indexOf("X11") != -1) os = "UNIX";
      if (objappVersion.indexOf("Linux") != -1) os = "Linux"; // In Chrome

      if ((objOffsetVersion = objAgent.indexOf("Chrome")) != -1) {
        channelName = "Chrome";
        objfullVersion = objAgent.substring(objOffsetVersion + 7).split(" ")[0];
      } // In Microsoft internet explorer
      else if ((objOffsetVersion = objAgent.indexOf("MSIE")) != -1) {
          channelName = "Microsoft Internet Explorer";
          objfullVersion = objAgent.substring(objOffsetVersion + 5).split(" ")[0];
        } // In Firefox
        else if ((objOffsetVersion = objAgent.indexOf("Firefox")) != -1) {
            channelName = "Firefox";
          } // In Safari
          else if ((objOffsetVersion = objAgent.indexOf("Safari")) != -1) {
              channelName = "Safari";
              objfullVersion = objAgent.substring(objOffsetVersion + 7).split(" ")[0];
              if ((objOffsetVersion = objAgent.indexOf("Version")) != -1) objfullVersion = objAgent.substring(objOffsetVersion + 8).split(" ")[0];
            } // For other browser "name/version" is at the end of userAgent
            else if ((objOffsetName = objAgent.lastIndexOf(" ") + 1) < (objOffsetVersion = objAgent.lastIndexOf("/"))) {
                channelName = objAgent.substring(objOffsetName, objOffsetVersion);
                objfullVersion = objAgent.substring(objOffsetVersion + 1).split(" ")[0];

                if (channelName.toLowerCase() == channelName.toUpperCase()) {
                  channelName = navigator.appName;
                }
              } // console.log("Your OS: " + os);
      // console.log("Your Channel: " + channel);
      // console.log("Your Channel Version: " + objfullVersion);
      // console.log("Your Channel Name: " + channelName);
      // console.log("Your Domain: " + domain);


      return {
        os: os,
        channel: channel,
        browser: {
          name: channelName,
          domain: domain,
          version: objfullVersion
        }
      };
    },
    toCustomDateFormat: function toCustomDateFormat(timeStamp) {
      var calculatedTime = 0,
          timerLimit = 85000
      /* 24 hours */
      ,
          time = ":00",
          hours,
          mins,
          secs,
          today = 0,
          yesterday = 0,
          isYesterday = true,
          contactDuration = Math.abs(new Date() - timeStamp);
      contactDuration = Math.round(contactDuration / 1000);
      yesterday = new Date(timeStamp);
      yesterday.setHours(0, 0, 0, 0);
      today = new Date();
      today.setHours(0, 0, 0, 0);
      isYesterday = today - yesterday == 86400000 ? true : false;

      if (isYesterday) {
        calculatedTime = "1 Day ago";
      } else if (contactDuration < timerLimit) {
        calculatedTime = this.toTimeString(timeStamp);
      } else {
        calculatedTime = Math.floor(contactDuration / timerLimit);
        calculatedTime = calculatedTime === 1 ? calculatedTime + " Day" : calculatedTime + " Days";
        calculatedTime = calculatedTime + " ago";
      }

      return calculatedTime;
    },
    findDaysCount: function findDaysCount(timeStamp) {
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

      var firstDate = new Date();
      var secondDate = new Date(timeStamp);
      var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));
      return diffDays;
    },
    secondsToTime: function secondsToTime(seconds) {
      var time = ":00",
          hours,
          mins,
          secs;

      if (seconds !== null && seconds !== undefined && typeof seconds === "number") {
        if (seconds <= 0) {
          return time;
        }

        hours = Math.floor(seconds / 3600), mins = Math.floor(seconds / 60) % 60, secs = seconds % 60;

        if (hours > 0) {
          time = hours + ":" + (mins > 9 ? mins : "0" + mins) + ":" + (secs > 9 ? secs : "0" + secs);
        } else if (mins <= 0) {
          time = ":" + (secs > 9 ? secs : "0" + secs);
        } else {
          time = mins + ":" + (secs > 9 ? secs : "0" + secs);
        }

        return time;
      } else if (seconds === 0) {
        return time;
      }

      return time;
    },
    sortWithKey: function sortWithKey(lists, attrName, sortDir) {
      lists.sort(function (a, b) {
        var x = parseInt(new Date(a[attrName]).getTime());
        var y = parseInt(new Date(b[attrName]).getTime());
        return sortDir * (x == y ? 0 : x > y ? 1 : -1);
      });
      return lists;
    },
    formatBytes: function formatBytes(bytes, decimals) {
      if (bytes == 0) return "0 Bytes";
      var k = 1000,
          dm = decimals + 1 || 3,
          sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    getFileTypeClass: function getFileTypeClass(fileName) {
      var fileName = fileName.toLowerCase();
      fileName = fileName.trim();
      var className = "fa fa-file";
      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(fileName)[1];

      if (ext === "txt") {
        className = "fa fa-file-text-o";
      } else if (ext === "doc" || ext === "docx") {
        className = "fa fa-file-word-o";
      } else if (ext === "xlsx" || ext === "xlsm" || ext === "xltx" || ext === "xltm") {
        className = "fa fa-file-excel-o";
      } else if (ext === "pdf") {
        className = "fa fa-file-pdf-o";
      } else if (ext === "png" || ext === "jpeg" | ext === "jpg") {
        className = "fa fa-file-picture-o";
      } else if (ext === "zip" || ext === "tar") {
        className = "fa fa-file-zip-o";
      } else if (ext === "mp4" || ext === "avi" || ext == "3gp" || ext === "mkv") {
        className = "fa fa-file-movie-o";
      } else if (ext === "mp3") {
        className = "fa fa-file-audio-o";
      }

      file = {
        className: className,
        ext: ext.toUpperCase()
      };
      return file;
    }
  };
}]);
"use strict";

mtChatApp.filter('to_trusted', ['$sce', function ($sce) {
  return function (text) {
    return $sce.trustAsHtml(text);
  };
}]).filter("trustUrl", ['$sce', function ($sce) {
  return function (Url) {
    return $sce.trustAsResourceUrl(Url);
  };
}]);
"use strict";

mtChatApp.service('utilService', ['$http', 'httpErrorFactory', 'constant', function ($http, httpErrorFactory, constant) {
  this.httpService = function (httpConfig) {
    httpConfig.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0';
    httpConfig.headers['Pragma'] = 'no-cache';
    httpConfig.headers['Expires'] = '0';
    $http({
      method: httpConfig.method,
      headers: httpConfig.headers,
      url: httpConfig.url,
      data: httpConfig.data,
      responseType: httpConfig.responseType
    }).success(function (data, status, headers, config) {
      httpConfig.successCallback(status, data, headers);

      if (typeof httpConfig.finallyCallback == 'function') {
        httpConfig.finallyCallback();
      }
    }).error(function (data, status, headers, config) {
      if (status == 403) {
        httpErrorFactory.error403();
      } else if (status == 401) {
        httpErrorFactory.error401();
      } else {
        httpConfig.failureCallback(status, data);

        if (typeof httpConfig.finallyCallback == 'function') {
          httpConfig.finallyCallback();
        }
      }
    });
  };
}]);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

mtChatApp.controller('ChatCntrl', ['$rootScope', '$scope', '$timeout', '$sce', 'FileUploader', 'constant', 'utilService', 'utilFactory', 'mqttService', 'dataService', function ($rootScope, $scope, $timeout, $sce, FileUploader, constant, utilService, utilFactory, mqttService, dataService) {
  logger.verbose("Load Chat Cntrl >>>>>");
  var a8bot_sto = {
    botHandles: {}
  };

  if (localStorage.a8bot_sto) {
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
  }

  $scope.sttOptions = {
    subscriptionKey: "e8d38e176e96433986aa481c46efb0f6",
    region: "westus",
    lang: "en-US",
    isSend: false
  };
  $scope.$on('onPlayAudio', function (event, audio) {
    $timeout(function () {
      $scope.ttsAudio = audio;
    });
  });
  $scope.isMic = false;

  if (constant.configuration.speechToText) {
    $scope.sttOptions = {
      subscriptionKey: config.subscriptionKey,
      region: constant.configuration.speechToText.region ? constant.configuration.speechToText.region : "westus",
      lang: constant.configuration.speechToText.lang ? constant.configuration.speechToText.lang : "en-US",
      isSend: constant.configuration.speechToText.isSend ? constant.configuration.speechToText.isSend : false
    };
    $scope.isMic = true;
  }

  var typingTimer = null;
  $scope.fabOptions = {
    button: {
      style: "large"
    },
    icon: {
      enable: 'add-enable.svg',
      disable: 'add-enable.svg'
    },
    position: "bottom-left",
    // "top-left" || "top-right" || "bottom-left" || "bottom-right"            
    direction: "vertical",
    // "horizontal" || "vertical"
    buttons: [{
      button: {
        style: "small blue"
      },
      icon: {
        enable: 'agent-enable.svg',
        disable: 'agent-disable.svg'
      },
      isEnable: true,
      action: 'disable',
      tooltip: "Connect to agent",
      onClick: function onClick() {
        // mqttService.transferToAgent();
        $scope.closeFileUpload();
        $scope.sendActivity("I would like to talk to an agent", "plain", "TransferToAgent");
      },
      id: "agentTransfer"
    }, {
      button: {
        style: "small yellow"
      },
      icon: {
        enable: 'attach-enable.svg',
        disable: 'attach-disable.svg'
      },
      isEnable: true,
      action: 'show',
      tooltip: "Attachment",
      onClick: function onClick() {
        $scope.showFileUpload();
      },
      id: "attachment"
    }],
    onOpen: function onOpen() {},
    onClose: function onClose() {}
  };
  $scope.chatBubbles = [];
  $scope.userInfo = dataService.userInfo;
  $scope.relateQuestions = [];
  var selectedTopics = getSelectedTopics();
  $scope.widgetUIState = dataService.widgetUIState;

  if (a8bot_sto.botHandles[dataService.botHandle].selectedTopics[selectedTopics.current].widgetUIState) {
    $scope.widgetUIState = a8bot_sto.botHandles[dataService.botHandle].selectedTopics[selectedTopics.current].widgetUIState;
  } else {
    // utilFactory.setValueToStore('widgetUIState', $scope.widgetUIState);
    a8bot_sto.botHandles[dataService.botHandle].selectedTopics[selectedTopics.current].widgetUIState = $scope.widgetUIState;
    updateStorage();
  }

  for (var opt in $scope.fabOptions.buttons) {
    if ($scope.widgetUIState[$scope.fabOptions.buttons[opt].id]) {
      $scope.fabOptions.buttons[opt].action = $scope.widgetUIState[$scope.fabOptions.buttons[opt].id];
    }
  }

  $scope.isSpeechTxtShow = false;
  $scope.isBotTyping = false;
  $scope.thumbnailPrev = null;
  $scope.thumbnailSel = null;
  $scope.isFileUploadShow = false; //assign botName from theme

  $scope.botName = constant.botTheme.bot.botName || "A8Bot"; //assign chat toolbarvisibility from theme

  $scope.toolBarVisibility = constant.botTheme.typingBox.toolBarVisibility; //assign chat typing box placeholder from theme

  $scope.typingPlaceholder = constant.botTheme.typingBox.placeholder; //assign botAvatar from theme 

  $scope.botAvatar = constant.botTheme.bot.botAvatar; //assign userAvatar from theme 

  $scope.userAvatar = constant.botTheme.user.userAvatar;
  $scope.overlayBubble = false;
  $scope.thumbsup = {};
  $scope.fileContentType = {
    image: ['image/jpg', 'image/png', 'image/jpeg'],
    video: ['video/mp4'],
    audio: ['audio/mp3'],
    pdf: ['application/pdf'],
    doc: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'],
    txt: ['text/plain'],
    xls: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'csv', 'application/vnd.ms-excel'],
    ppt: ['application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-powerpoint']
  };
  var fileUploadURLMapper = {};
  var uploader = $scope.uploader = new FileUploader({
    method: "PUT"
  });
  $scope.isStopComments = false;
  $scope.feedback = {
    isOpen: false,
    id: null,
    isThumb: null,
    comment: null
  };
  uploader.filters.push({
    name: 'imageFilter',
    fn: function fn(item
    /*{File|FileLikeObject}*/
    , options) {
      var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
      return '|jpg|png|jpeg|bmp|gif|pdf|doc|docx|txt|xls|docs|vnd.ms-excel|msword|vnd.openxmlformats-officedocumnet.wordprocessingml.document|vnd.ms-powerpoint|plain|'.indexOf(type) !== -1;
    }
  });
  $scope.isRelateQuestionsOpen = false;
  $scope.thumbsupLastTouched = null;

  if (dataService.userInfo && dataService.userInfo.thumbsupLastTouched != null) {
    $scope.thumbsupLastTouched = utilFactory.findDaysCount(dataService.userInfo.thumbsupLastTouched);
  }

  $scope.isAllowMsg = function (text) {
    var status = true;

    if (utilFactory.isNotNullOrUndefinedString(text) && text.trim().length == 0) {
      status = false;
    }

    return status;
  };

  $scope.stopBotTyping = function () {
    $scope.isBotTyping = false;
    dataService.isBotTyping = false;
    $scope.$broadcast('setPos');

    if ($scope.relateQuestions.length > 0) {
      $scope.isRelateQuestionsOpen = true;
    }
  };

  $scope.$on('onBotTypingEventStart', function (event, data) {
    var waitTime = data.waitTime && data.waitTime != 0 ? data.waitTime : 1000;
    logger.verbose("onBotTypingEventStart: " + waitTime);
    $timeout.cancel(typingTimer);

    if (!dataService.isBotTyping) {
      $timeout(function () {
        $scope.isBotTyping = true;
        dataService.isBotTyping = true;
        $scope.$broadcast('setPos');
      });
    }

    typingTimer = $timeout(function () {
      $scope.stopBotTyping();
    }, waitTime);
  });
  $scope.$on('onBotTypingEventStop', function (event) {
    $scope.stopBotTyping();
  });
  $scope.$on('onOverlayBubble', function (event, isFlag) {
    $timeout(function () {
      $scope.overlayBubble = isFlag;
    });
  });
  $scope.$on('onMessageUpdate', function (event, data) {
    logger.verbose("Chat Cntrl Message Update");
    var msg = null;

    if (dataService.chat.msg.length > 0) {
      msg = dataService.chat.msg[dataService.chat.msg.length - 1];
    }

    if ((dataService.tabStatus == "" || dataService.tabStatus == "Close") && msg != null) {
      // var msg = dataService.chat.msg[dataService.chat.msg.length - 1];
      if (msg.from.userId != $scope.userInfo.userId) {
        // need to remove
        // dataService.botName = msg.from.name;
        // $scope.botName = dataService.botName;
        parent.postMessage({
          type: 'Notification',
          msg: msg,
          tabStatus: dataService.tabStatus
        }, dataService.hostedURL);
      }
    }

    if (data.action == "New") {
      $scope.$broadcast("hideChoices");

      if (msg != null && msg.from.userId != $scope.userInfo.userId) {
        $scope.stopBotTyping();
      }

      $scope.chatBubbles = dataService.chat.msg;
      $scope.$digest();
    } else if (data.action == "Error") {
      dataService.chat.msg[dataService.chat.msg.length - 1]['retry'] = true;
    } else if (data.action == "Sent" && dataService.chat.msg[dataService.chat.msg.length - 1].retry) {
      dataService.chat.msg[dataService.chat.msg.length - 1]['retry'] = false;
    } else if (data.action == "Inbox") {
      $scope.chatBubbles = dataService.chat.msg; // parent.postMessage({ type: 'Inbox', tabStatus: dataService.tabStatus }, dataService.hostedURL);
    }

    scrollBarSetToBottom();
  }); // $scope.$on('onKBStatus', function (event, data) {
  //     // console.log(data);
  // });

  $scope.$on('onUploadFile', function (event, data) {
    $scope.sendActivity(data.file, "file", "Attachment");
  });
  $scope.$on('onAttachActionEnable', function (event, data) {
    $rootScope.$broadcast('setWidth');
    $scope.attachActionEnable = dataService.attachActionEnable;
  });
  $scope.$on('onWidgetUIState', function (event, data) {
    if (data.keyboard) {
      $scope.widgetUIState.keyboard = data.keyboard.toLowerCase();
    }

    if (data.agentTransfer) {
      $scope.widgetUIState.agentTransfer = data.agentTransfer.toLowerCase();
    }

    if (data.attachment) {
      $scope.widgetUIState.attachment = data.attachment.toLowerCase();
    }

    dataService.widgetUIState = $scope.widgetUIState;
    $timeout(function () {
      for (var opt in $scope.fabOptions.buttons) {
        if (data[$scope.fabOptions.buttons[opt].id]) {
          $scope.fabOptions.buttons[opt].action = data[$scope.fabOptions.buttons[opt].id];
        }
      }
    });
  });
  $scope.$on('onSuggestionUpdate', function (event, data) {
    $scope.relateQuestions = [];

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        $scope.relateQuestions = $scope.relateQuestions.concat(data[key].questions);
      }
    }

    $scope.isRelateQuestionsOpen = true;
  });
  $scope.$on('onTabEvent', function (event) {
    if (dataService.tabStatus != "") {
      scrollBarSetToBottom();
    }
  });
  $scope.$on('onSendRichReply', function (event, replyMsg) {
    $scope.$broadcast("hideChoices");
    var msg = {
      'id': utilFactory.generateMsgId(),
      'from': {
        'userId': dataService.userInfo.userId,
        'displayName': dataService.userInfo.displayName
      },
      "msg": JSON.parse(angular.toJson(replyMsg.msg)),
      "msgType": replyMsg.msgType,
      "timestamp": null,
      "suggesstion": false
    };
    $scope.dataService.chat.msg.push(msg);
    sendMessage(msg);
    scrollBarSetToBottom();
  });
  $scope.$on('onNotificationReply', function (event, replyMsg, nReplyId, triggeredBy) {
    $scope.sendActivity(replyMsg, 'notification', triggeredBy);

    if (nReplyId != null) {
      delete dataService.notificaitonReplyQueue[nReplyId];
    }
  });
  utilFactory.generateMsgId();

  $scope.formattingName = function (name) {
    if (name) {
      return name.charAt(0).toUpperCase(); // return name.split(" ")[0].charAt(0);
    } // if (obj && obj.from && obj.from.displayName) {
    //     return obj.from.displayName.split(" ")[0].charAt(0);// + (utilFactory.isNotNullOrUndefinedString(name.split(" ")[1]) === true ? name.split(" ")[1].charAt(0) : "");
    // } else if (obj && obj.from && obj.from.displayName) {
    //     return obj.from.displayName.split(" ")[0].charAt(0);// + (utilFactory.isNotNullOrUndefinedString(name.split(" ")[1]) === true ? name.split(" ")[1].charAt(0) : "");
    // }

  };

  $scope.chatBubblesScrollConfig = {
    autoHideScrollbar: true,
    theme: 'light',
    advanced: {
      updateOnContentResize: true
    },
    scrollInertia: 0,
    callbacks: {
      onUpdate: function onUpdate() {
        $timeout(function () {
          $($(".bot .txt")[$(".bot .txt").length - 1]).addClass('animate');
          $($(".client .txt")[$(".client .txt").length - 1]).addClass('animate');
        }, 3000);
      }
    }
  };
  $scope.suggestionScrollConfig = {
    autoHideScrollbar: false,
    theme: 'light',
    axis: 'x',
    advanced: {
      updateOnContentResize: true,
      autoExpandHorizontalScroll: true
    },
    scrollInertia: 0
  };

  $scope.formattingDateTime = function (timestamp) {
    return utilFactory.toCustomDateTimeFormat(new Date(new Date(timestamp).getTime()));
  };

  $scope.sendActivity = function (query, isMsgSent, triggeredBy) {
    var isAllow = {
      "ReplyMessage": $scope.widgetUIState.keyboard != "disable" && $scope.widgetUIState.keyboard != "hide",
      "SimpleChoice": true,
      "OAuth": true,
      "TypingPanel": $scope.widgetUIState.keyboard != "disable" && $scope.widgetUIState.keyboard != "hide" && triggeredBy == "TypingPanel" && (utilFactory.isNotNullOrUndefinedString(query) || utilFactory.isNotNullOrUndefinedString($scope.typingArea)),
      "TransferToAgent": $scope.widgetUIState.agentTransfer != "disable" && $scope.widgetUIState.agentTransfer != "hide",
      "Attachment": $scope.widgetUIState.attachment != "disable" && $scope.widgetUIState.attachment != "hide",
      "Surfacing": true,
      "VoiceMsg": true
    };

    if (isAllow[triggeredBy]) {
      $scope.$broadcast("hideChoices");
      checkChatBubbleMsg();
      dataService.tabStatus = 'Open';
      $scope.isRelateQuestionsOpen = false;
      var data = null;

      if ($scope.uploader.queue.length > 0) {
        $scope.uploader.queue.length = 6;
        $scope.uploader.uploadAll();
        return;
      }

      if (utilFactory.isNotNullOrUndefinedString(query) || utilFactory.isNotNullOrUndefinedString($scope.typingArea)) {
        if (!query) {
          query = $scope.typingArea;
          $scope.typingArea = "";
        }

        if (triggeredBy != "SimpleChoice" && triggeredBy != "OAuth") {
          var map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            "/": '&#x2F;'
          };
          var reg = /[&<>"'/]/ig;
          query = query.replace(reg, function (match) {
            return map[match];
          });
        }

        data = {
          "id": utilFactory.generateMsgId(),
          "msgType": "text",
          "msg": {
            "text": query
          },
          'from': {
            'userId': dataService.userInfo.userId,
            'displayName': dataService.userInfo.displayName
          },
          "timestamp": null,
          "isMsgSent": isMsgSent
        };

        if (data != null) {
          if (checkDuplicateMsg(data, dataService.chat.msg)) {
            dataService.chat.msg.push(data);
          }

          sendMessage(data);
          $scope.typingArea = '';
        }
      }
    }
  };

  function checkDuplicateMsg(data, array) {
    var isRender = true;
    angular.forEach(array, function (item, index) {
      if (item != null && item.id == data.id) {
        if (item.msg && data.msg) {
          item.msg = data.msg;
        }

        isRender = false;
      }
    });
    return isRender;
  }

  function getSelectedTopics() {
    a8bot_sto = JSON.parse(localStorage.a8bot_sto);

    if (typeof a8bot_sto.botHandles[dataService.botHandle].selectedTopics == "string") {
      return JSON.parse(a8bot_sto.botHandles[dataServeice.botHandle].selectedTopics);
    } else if (_typeof(a8bot_sto.botHandles[dataService.botHandle].selectedTopics) == "object") {
      return a8bot_sto.botHandles[dataService.botHandle].selectedTopics;
    } else {
      return null;
    }
  }

  function sendFileActivity(fileItem) {
    var msg = {
      'id': fileItem.id,
      'from': {
        'userId': dataService.userInfo.userId,
        'displayName': dataService.userInfo.displayName
      },
      "msg": {
        "url": fileItem.thumbnail,
        "fileName": fileItem.file.name,
        "fileSize": fileItem.file.size,
        "hashKey": fileItem.$$hashKey,
        "desc": fileItem.desc
      },
      "msgType": $scope.getFileType(fileItem.file.type),
      "timestamp": null,
      "suggesstion": false
    };
    $scope.dataService.chat.msg.push(msg);
    scrollBarSetToBottom(); // fileItem.uploader.uploadItem(fileItem);
  }

  ; // $scope.retryMsg = function (msg) {
  //     sendMessage(msg, true);
  // }

  $scope.isTypingArea = function (isEnter) {// if (!isEnter && $scope.typingArea) {
    //     isEnter = $scope.typingArea.length > 0 ? true : false;
    // }
    // if ($scope.sendActionEnable != isEnter) {
    //     $timeout(function () {
    //         $scope.sendActionEnable = isEnter;
    //         dataService.sendActionEnable = isEnter;
    //         $scope.$broadcast('setWidth');
    //     }, 500);
    // }
  };

  function checkChatBubbleMsg() {
    angular.forEach($scope.chatBubbles, function (item, index) {
      if (item == null) {
        $scope.chatBubbles.splice(index, 1);
      }
    });
  }

  $scope.isUserTyping = function (e) {
    checkChatBubbleMsg();

    if ($scope.thumbnailSel != null) {
      if ($scope.typingArea && $scope.typingArea.length > 0) {
        $timeout(function () {
          for (var i in $scope.uploader.queue) {
            if ($scope.uploader.queue[i].$$hashKey == $scope.thumbnailSel.hashKey) {
              $scope.uploader.queue[i].desc = $scope.typingArea;
            }
          }
        });
      }

      return;
    } // var keyCode = window.event ? e.keyCode : e.which;
    // $timeout(function () {
    //     if ($scope.typingArea && $scope.typingArea.length > 0) {
    //         if ($scope.chatBubbles.length > 0 && $scope.chatBubbles[$scope.chatBubbles.length - 1]['isUserTyping'] == "STARTED") {
    //             $scope.chatBubbles.splice($scope.chatBubbles.length - 1, 1);
    //         }
    //         $scope.chatBubbles.push({
    //             'id': utilFactory.generateMsgId(),
    //             'isUserTyping': 'STARTED',
    //             'msgType': "text",
    //             'from': {
    //                 'userId': dataService.userInfo.userId,
    //                 'displayName': dataService.userInfo.displayName
    //             },
    //             'msg': {
    //                 'text': $scope.typingArea
    //             },
    //             'timestamp': null
    //         });
    //     } else {
    //         if ($scope.chatBubbles.length > 0 && $scope.chatBubbles[$scope.chatBubbles.length - 1]['isUserTyping']) {
    //             if (keyCode == 13) {
    //                 $scope.chatBubbles[$scope.chatBubbles.length - 1]['isUserTyping'] = 'COMPLETED';
    //             } else if ($scope.chatBubbles[$scope.chatBubbles.length - 1]['isUserTyping'] == "STARTED") {
    //                 $scope.chatBubbles.splice($scope.chatBubbles.length - 1, 1);
    //             }
    //         }
    //     }
    //     mqttService.sendTypeSenseText($scope.typingArea);
    //     scrollBarSetToBottom();
    // });

  };

  $scope.closeFeedback = function (isThumb, chatMsg) {
    $scope.feedback.isOpen = false;
    $scope.overlayBubble = false;
  };

  $scope.overlayBubbleAction = function () {
    if ($scope.feedback.isOpen == true) {
      $scope.setThumbs();
    }
  };

  $scope.openFeedback = function (isThumb, chatMsg) {
    $scope.feedback = {
      isOpen: false,
      id: chatMsg.id,
      isThumb: isThumb,
      comment: null
    };

    if (($scope.thumbsupLastTouched == null || $scope.thumbsupLastTouched > constant.LimitDaysForThumbup || isThumb == false) && ($scope.isStopComments == false || isThumb == false)) {
      $scope.feedback.isOpen = true;
      $scope.overlayBubble = true;
      $scope.$broadcast('setHeight');
      $scope.$broadcast('renderSVG');

      if (isThumb == true) {
        $scope.isStopComments = true;
      }

      $scope.$broadcast('showFocus', '_comment');
    } else {
      $scope.thumbsup[chatMsg.id] = {
        'status': 'completed',
        'isThumb': isThumb
      };
      $scope.setThumbs();
    }
  };

  $scope.setThumbs = function () {
    // && utilFactory.isNotNullOrUndefinedString($scope.feedback.comment)
    if (utilFactory.isNotNullOrUndefinedString($scope.feedback.id)) {
      var httpConfig = {
        "url": window.baseURL + config.setThumbsURL,
        "method": "POST",
        "data": {
          "userId": dataService.userInfo.userId,
          "thumbsup": $scope.feedback.isThumb,
          "id": $scope.feedback.id,
          "clientId": dataService.userInfo.clientId,
          "comment": $scope.feedback.comment
        },
        "headers": {
          "Content-Type": "application/json"
        },
        "successCallback": function successCallback(status, data, headers) {
          $scope.thumbsup[$scope.feedback.id] = {
            'status': 'completed',
            'isThumb': $scope.feedback.isThumb
          };
          $scope.$broadcast('showFocus', '_typingText');

          if (data == 'success') {
            $scope.feedback = {
              isOpen: false,
              id: null,
              isThumb: null,
              comment: null
            };
            $scope.overlayBubble = $scope.feedback.isOpen;
          }
        },
        "failureCallback": function failureCallback(status, data) {
          logger.verbose("Thumb failuer: status: " + status + " :data: " + data);
        }
      };
      utilService.httpService(httpConfig);
    }
  };

  function scrollBarSetToBottom() {
    $scope.$broadcast('showFocus', '_typingText');
    $(".bot .txt")[$(".bot .txt").length - 1];
    $timeout(function () {
      $scope.overlayBubble = $scope.feedback.isOpen;

      if ($scope.uploader.queue.length > 0) {
        $scope.overlayBubble = true;
      }

      $("#chatBubblesScroll").mCustomScrollbar("scrollTo", "bottom", {
        scrollEasing: "easeOut",
        callbacks: {
          onUpdate: function onUpdate() {// console.log("Scrollbars updated");
          }
        }
      });
    });
  }

  function sendMessage(data, isRetry) {
    $scope.isRelateQuestionsOpen = false;
    $scope.relateQuestions = [];
    mqttService.sendMsg(data, isRetry);
  }

  $timeout(function () {
    $scope.$broadcast('setHeight');
    $scope.$broadcast('setWidth');
    $scope.$broadcast('showFocus', '_typingText');
    $scope.chatBubbles = dataService.chat.msg;

    if ($scope.chatBubbles.length > 0) {
      scrollBarSetToBottom();
    }
  }, 1000);

  $scope.htmlAction = function (id, chosen, actionType, choices) {
    var msg = {
      "ref_id": id,
      "msgType": "text",
      "msg": {
        text: ""
      },
      "chosen": chosen,
      "timestamp": new Date(),
      "actionType": actionType,
      "isMsgSent": "plain",
      "choices": choices
    };
    sendMessage(msg, false);
  };

  $scope.trustAsHtml = function (string) {
    return $sce.trustAsHtml(string);
  }; //File Upload


  $scope.uploader.onCompleteAll = function (resp) {
    logger.verbose("Complete All: " + JSON.stringify(resp));
    $scope.closeFileUpload();
  };

  $scope.uploader.onProgressAll = function (resp) {
    logger.verbose("Progress All: " + JSON.stringify(resp));
  };

  $scope.uploader.onAfterAddingFile = function (fileItem) {
    //console.info('onAfterAddingFile', fileItem);
    var fileName = fileItem._file.name,
        fileDetails = fileName.split(/[\s.]+/),
        fileExt = fileDetails[fileDetails.length - 1];
    validateAttachment(fileItem, fileExt);
  };

  $scope.uploader.onBeforeUploadItem = function (item) {
    item.url = fileUploadURLMapper[item.$$hashKey];
    item.disableMultipart = true;
    $scope.uploader.url = fileUploadURLMapper[item.$$hashKey];
  };

  $scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    var msg = {
      'id': utilFactory.generateMsgId(),
      'from': {
        'userId': dataService.userInfo.userId,
        'displayName': dataService.userInfo.displayName
      },
      "msg": {
        "url": fileItem.url.split('?')[0],
        "fileName": fileItem.file.name,
        "fileSize": fileItem.file.size,
        "desc": fileItem.desc
      },
      "msgType": $scope.getFileType(fileItem.file.type),
      "timestamp": null,
      "suggesstion": false
    };
    fileItem.id = msg.id;
    sendFileActivity(fileItem); // console.info('Uploader Success: ', fileItem, response, status, headers);

    sendMessage(msg, false);
  };

  $scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info('Uploader Error: ', fileItem, response, status, headers);
  };

  function validateAttachment(fileItem, fileExt) {
    var httpConfig = {
      "url": window.baseURL + config.attachmentUrl + "?fileExt=" + fileExt + "&orgId=" + $scope.userInfo.orgId,
      "method": "GET",
      "headers": {
        "Content-Type": "application/json",
        "x-app-key": dataService.userInfo.appKey,
        "x-org-id": dataService.userInfo.orgId,
        "x-client-id": dataService.userInfo.clientId,
        "x-bot-handle": dataService.userInfo.botHandle
      },
      "data": {
        "fileExt": fileExt,
        "clientId": "uuid4"
      },
      "successCallback": function successCallback(status, data, headers) {
        fileUploadURLMapper[fileItem.$$hashKey] = {};
        fileUploadURLMapper[fileItem.$$hashKey] = data.url;
        var reader = new FileReader();
        reader.readAsDataURL(fileItem._file);

        reader.onloadend = function (e) {
          for (var i in $scope.uploader.queue) {
            if ($scope.uploader.queue[i].$$hashKey == fileItem.$$hashKey) {
              $scope.uploader.queue[i].thumbnail = reader.result;
              $scope.uploader.queue[i].desc = "";
            }
          } // fileUploadURLMapper[fileItem.$$hashKey].thumbnails = reader.result;

        }; // sendFileActivity(fileItem, data.url);


        logger.verbose("Success:" + JSON.stringify(data));
      },
      "failureCallback": function failureCallback(status, data) {
        logger.error(JSON.stringify(data));
        fileItem.remove();
      }
    };
    utilService.httpService(httpConfig);
  }

  $scope.getFileType = function (type) {
    for (var i in $scope.fileContentType) {
      if ($scope.fileContentType[i].indexOf(type) > -1) {
        return i;
      }
    }
  };

  $scope.loadThumbnailPrev = function (item) {
    if (item) {
      $scope.thumbnailPrev = {
        src: item.thumbnail,
        desc: item.desc,
        name: item.file.name,
        size: (item.file.size / 1024 / 1024).toFixed(2) + ' MB',
        hashKey: item.$$hashKey,
        type: $scope.getFileType(item.file.type)
      };
    } else {
      $timeout(function () {
        $scope.thumbnailPrev = null;
      });
    }
  };

  $scope.loadThumbnailSelected = function (item) {
    if (item) {
      $scope.thumbnailSel = {
        hashKey: item.$$hashKey
      };
      $scope.typingArea = item.desc;
    }
  };

  $scope.showFileUpload = function () {
    $scope.isFileUploadShow = true;

    if ($scope.isFileUploadShow) {
      angular.element('#openFileBrowser').trigger('click');
    }
  };

  $scope.closeFileUpload = function () {
    $scope.isFileUploadShow = false;
    $scope.uploader.queue = [];
  };

  $scope.showSpeechTxt = function () {
    $scope.overlayBubble = false;
    $scope.isSpeechTxtShow = true;
    $rootScope.$broadcast('onSpeechStart');
  };

  $scope.$on("onSpeechStop", function (event, data) {
    $timeout(function () {
      $scope.overlayBubble = false;
      $scope.isSpeechTxtShow = false;

      if (data && data.text) {
        if ($scope.sttOptions.isSend) {
          $scope.sendActivity(data.text.substring(0, data.text.length - 1), "Voice", "VoiceMsg");
        } else {
          $scope.typingArea = data.text.substring(0, data.text.length - 1);
        }
      }
    });
  });
  $scope.$watchCollection('uploader.queue', function (newVal, oldVal) {
    $timeout(function () {
      if ($scope.uploader.queue.length == 0) {
        $scope.thumbnailSel = null;
        $scope.thumbnailPrev = null;
        $scope.isFileUploadShow = false;
        $scope.overlayBubble = false;
      } else {
        $scope.overlayBubble = true;
      }
    });
  });

  function updateStorage() {
    // console.trace();
    // console.log("B: ",localStorage.a8bot_sto)
    localStorage.setItem('a8bot_sto', JSON.stringify(a8bot_sto)); // console.log("A: ",localStorage.a8bot_sto)

    a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    $rootScope.$broadcast('onStorageUpdate', {
      'triggeredBy': 'CHAT'
    });
  }

  $scope.$on('onStorageUpdate', function (event, triggeredBy) {
    if (triggeredBy != "CHAT") {
      a8bot_sto = JSON.parse(localStorage.a8bot_sto);
    }
  });
  parent.postMessage({
    type: 'ChatWindowLoaded'
  }, dataService.hostedURL);
}]);